<template lang="pug">
	.project-settings-sections
		.sections-header
			.sections-title Sections
			.controls-wrapper
				.show-history-button(@click="showChangeHistory()" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Show change history', html: true}")
					.fa.fa-history
				.create-new-section-button(@click="createNewSection()" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Create a new section', html: true}")
					.fa.fa-plus

		div
			small.text-muted In the each template section you can change image, css styles and other settings
		.section-list
			.section-list-item(v-for="section in sections" v-if="!section.Data.hidden && (section.template_id !== 6 || (section.codename !== '300x250' || (playerStyle === '300x250')))" v-on:click="expandSection(section, $event)" v-pseudo-modal-name="'project-section-settings-' + section.id")
				.section-list-main
					.section-list-name {{ section.title }}
					.section-list-edit(v-if="section" v-pseudo-modal-name="'project-section-control-buttons'")
						.section-list-edit-item(v-if="section.isChanged")
							i.icon-info.icons.font-2xl(v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'This section was changed'}")
						.section-list-edit-item(v-if="section.Data.disabled")
							i.icon-info.icons.font-2xl(v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'This section is disabled and not uses in the creative'}")
						.section-list-edit-item.control-item(v-if="section.Data.parent" @click="highlightSection(section, $event)" :class="section.Data['highlighted'] ? 'orange' : ''")
							i.fa.fa-eye(v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Highlight section dimensions in preview'}")
						.section-list-edit-item.control-item.section-list-edit-reset(@click="resetSection(section)" v-b-tooltip.hover="{delay: { show: 1500, hide: 100 }, title: 'Reset to default'}")
							i.fa.fa-rotate-left
						.section-list-edit-item.control-item.section-list-edit-close.red(@click="disableSection(section)" v-b-tooltip.hover="{delay: { show: 1500, hide: 100 }, title: section.Data.disabled ? 'Enable section' : 'Disable section'}")
							i.fa(:class="{'fa-times': !section.Data.disabled, 'fa-refresh': section.Data.disabled}")
				.section-list-item-settings(v-if="expandedSectionId === section.id && (section.Data.placement === 'bottom' && section.template_id !== 5)")
					.basic-section
						.section-settings-tab
							.section-setting.in-a-row
								small.left-title.text-muted Z index
								input.right-control.form-control.form-control-sm.small-width(type="text" :value="section.Data.styles ? section.Data.styles['z-index'] : 0" placeholder="0" v-on:input="setSectionStyle(section, 'z-index', $event.target.value)" v-on:change="saveSectionStyle(section, 'z-index', $event.target.value)")
							.section-setting.in-a-row
								small.left-title.text-muted Section image
								select.right-control.custom-select.custom-select-sm(v-on:input="setSectionData(section, 'assetCodename', $event.target.value)" v-on:change="Section.saveSectionData(section, 'assetCodename', $event.target.value)")
									option(:selected="section.Data.assetCodename === 'none'" :value="'none'") None
									option(v-for="asset in Asset.AssetsByProject[section.project_id]" :selected="section.Data.assetCodename === asset.codename" :value="asset.codename") {{asset.codename}}

						.section-settings-tab
							.section-setting.in-a-row
								small.left-title.text-muted Width
								input.right-control.form-control.form-control-sm.small-width(type="text" :value="section.Data['width'] || 970" placeholder="970" v-on:input="setSectionData(section, 'width', $event.target.value)" v-on:change="Section.saveSectionData(section, 'width', $event.target.value)")
							.section-setting.in-a-row
								small.left-title.text-muted Height
								input.right-control.form-control.form-control-sm.small-width(type="text" :value="section.Data.hasOwnProperty('height') ? section.Data['height'] : 150" placeholder="'150'" v-on:input="setSectionData(section, 'height', $event.target.value)" v-on:change="Section.saveSectionData(section, 'height', $event.target.value)")

						.section-settings-tab
							.section-setting.in-a-row
								small.left-title.text-muted Hidden opacity
								input.right-control.form-control.form-control-sm.small-width(type="text" :value="section.Data['hidden-opacity'] || 0" placeholder="0" v-on:input="setSectionData(section, 'hidden-opacity', $event.target.value)" v-on:change="Section.saveSectionData(section, 'hidden-opacity', $event.target.value)")
							.section-setting.in-a-row
								small.left-title.text-muted Hidden transform
								input.right-control.form-control.form-control-sm.full-width(type="text" :value="section.Data.hasOwnProperty('hidden-transform') ? section.Data['hidden-transform'] : 'scale(2)'" placeholder="'scale(2)'" v-on:input="setSectionData(section, 'hidden-transform', $event.target.value)" v-on:change="Section.saveSectionData(section, 'hidden-transform', $event.target.value)")
							.section-setting.in-a-row
								small.left-title.text-muted Hide duration
								input.right-control.form-control.form-control-sm.small-width(type="text" :value="section.Data.hasOwnProperty('hide-duration') ? section.Data['hide-duration'] : 0.5" placeholder="0.5" v-on:input="setSectionData(section, 'hide-duration', $event.target.value)" v-on:change="Section.saveSectionData(section, 'hide-duration', $event.target.value)")

						.delete-section-button(v-if="section.Data.newTitle" @click="deleteSection(section.id)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, html: true}")
							.btn.btn-sm.btn-block.btn-outline-danger
								small.left-title Remove section
				.section-list-item-settings(v-else-if="expandedSectionId === section.id && section.template_id !== 8 && section.template_id !== 10 && section.template_id !== 9 && section.template_id !== 11")

					.background-section(v-if="section.codename === 'background'")
						.section-settings-tab.styles-settings
							.section-settings.in-a-row
								small.left-title.text-muted Section visibility
								select.right-control.custom-select.custom-select-sm.default-width(v-on:input="setSectionStyle(section, 'visibility', $event.target.value)" v-on:change="saveSectionStyle(section, 'visibility', $event.target.value)")
									option(:selected="(section.Data.styles && section.Data.styles.visibility === 'visible') || !section.Data.styles" value="visible") Visible
									option(:selected="section.Data.styles && section.Data.styles.visibility === 'hidden'" value="hidden") Hidden
									option(:selected="section.Data.styles && section.Data.styles.visibility === 'collapse'" value="collapse") Collapse
									option(:selected="section.Data.styles && section.Data.styles.visibility === 'inherit'" value="inherit") Inherit
							.section-settings.in-a-row
								small.left-title.text-muted Z index
								input.right-control.form-control.form-control-sm.small-width(type="text" :value="section.Data.styles ? section.Data.styles['z-index'] : 0" placeholder="0" v-on:input="setSectionStyle(section, 'z-index', $event.target.value)" v-on:change="saveSectionStyle(section, 'z-index', $event.target.value)")
							.section-settings.in-a-row
								small.left-title.text-muted Image repeat
								select.right-control.custom-select.custom-select-sm.default-width(v-on:input="setSectionStyle(section, 'background-repeat', $event.target.value)" v-on:change="saveSectionStyle(section, 'background-repeat', $event.target.value)")
									option(:selected="section.Data.styles[\"background-repeat\"] === 'no-repeat'" value="no-repeat") No repeat
									option(:selected="section.Data.styles[\"background-repeat\"] === 'repeat'" value="repeat") Repeat
									option(:selected="section.Data.styles[\"background-repeat\"] === 'repeat-x'" value="repeat-x") Repeat x
									option(:selected="section.Data.styles[\"background-repeat\"] === 'repeat-y'" value="repeat-y") Repeat y
									option(:selected="section.Data.styles[\"background-repeat\"] === 'round'" value="round") Round
									option(:selected="section.Data.styles[\"background-repeat\"] === 'space'" value="space") Space
							.section-settings.in-a-row
								small.left-title.text-muted Background attachment
								select.right-control.custom-select.custom-select-sm.default-width(v-on:input="setSectionStyle(section, 'background-attachment', $event.target.value)" v-on:change="saveSectionStyle(section, 'background-attachment', $event.target.value)")
									option(:selected="section.Data.styles[\"background-attachment\"] === 'scroll'" value="scroll") Scroll
									option(:selected="section.Data.styles[\"background-attachment\"] === 'fixed'" value="fixed") Fixed
									option(:selected="section.Data.styles[\"background-attachment\"] === 'fixed-side'" value="fixed-side") Fixed along with side sections
							.section-settings.in-a-row(v-if="section.template_id === 3 || section.template_id === 2 || section.template_id === 4")
								small.left-title.text-muted Override position
								input.right-control.form-control.form-control-sm.full-width(type="text" :value="section.Data['override-background-position']" v-on:input="setSectionData(section, 'override-background-position', $event.target.value)" v-on:change="Section.saveSectionData(section, 'override-background-position', $event.target.value)")

							.section-settings.in-a-row(v-if="section.template_id === 3 || section.template_id === 2 || section.template_id === 4")
								small.left-title.text-muted Override size
								input.right-control.form-control.form-control-sm.full-width(type="text" :value="section.Data['override-background-size']" v-on:input="setSectionData(section, 'override-background-size', $event.target.value)" v-on:change="Section.saveSectionData(section, 'override-background-size', $event.target.value)")


					.basic-section(v-if="section.type !== 'interstitial' && section.codename !== 'background'")

						.section-settings-tab.styles-settings(v-if="section.template_id !== 6 || (section.template_id === 6 && (section.type === 'twitch' || section.type === 'hls'))")
							.section-setting.in-a-row
								small.left-title.text-muted Section visibility
								select.right-control.custom-select.custom-select-sm(v-on:input="setSectionStyle(section, 'visibility', $event.target.value)" v-on:change="saveSectionStyle(section, 'visibility', $event.target.value)")
									option(:selected="(section.Data.styles && section.Data.styles.visibility === 'visible') || !section.Data.styles" value="visible") Visible
									option(:selected="section.Data.styles && section.Data.styles.visibility === 'hidden'" value="hidden") Hidden
									option(:selected="section.Data.styles && section.Data.styles.visibility === 'collapse'" value="collapse") Collapse
									option(:selected="section.Data.styles && section.Data.styles.visibility === 'inherit'" value="inherit") Inherit
							.section-setting.in-a-row
								small.left-title.text-muted Z index
								input.right-control.form-control.form-control-sm.small-width(type="text" :value="section.Data.styles ? section.Data.styles['z-index'] : 0" placeholder="0" v-on:input="setSectionStyle(section, 'z-index', $event.target.value)" v-on:change="saveSectionStyle(section, 'z-index', $event.target.value)")


						.section-settings-tab.section.type-for-twitch-template(v-if="section.template_id === 6 && (section.type === 'twitch' || section.type === 'hls')")
							.section-settings.in-a-row
								small.left-title.text-muted Section type
								select.right-control.custom-select.custom-select-sm(v-on:input="setSectionType(section, $event.target.value)" v-on:change="Section.saveSectionType(section, $event.target.value)")
									option(:selected="section.type === 'channel'" value="twitch") Twitch
									option(:selected="section.type === 'hls'" value="hls") Unbranded video

						.section-settings-tab.section-type-for-twitch-template(v-if="section.template_id === 6 && (section.type === 'twitch' || section.type === 'hls')")
							.group(v-if="section.type === 'twitch'")
								.section-settings.in-a-row
									small.left-title.text-muted Content type
									select.right-control.custom-select.custom-select-sm(v-on:input="setSectionData(section, 'twitch-type', $event.target.value)" v-on:change="Section.saveSectionData(section, 'twitch-type', $event.target.value)")
										option(:selected="section.Data['twitch-type'] === 'channel'" value="channel") Channel
										option(:selected="section.Data['twitch-type'] === 'video'" value="video") Video
										option(:selected="section.Data['twitch-type '] === 'collection'" value="collection") Collection
								.section-settings.in-a-row
									small.left-title.text-muted {{section.Data['twitch-type'] || 'Channel'}}
									input.form-control.form-control-sm.full-width(type="text" v-on:input="setSectionData(section, 'twitch-content', $event.target.value)" v-on:change="Section.saveSectionData(section, 'twitch-content', $event.target.value)" :value="section.Data['twitch-content']")
								.section-settings.in-a-row
									small.left-title.text-muted Override json key
									input.form-control.form-control-sm.full-width(type="text" v-on:input="setSectionData(section, 'override-json-key', $event.target.value)" v-on:change="Section.saveSectionData(section, 'override-json-key', $event.target.value)" :value="section.Data['override-json-key']")
							.group(v-else-if="section.type === 'hls'")
								.section-settings.in-a-row
									small.left-title.text-muted Video
									select.right-control.custom-select.custom-select-sm.full-width(v-on:input="setSectionData(section, 'video', $event.target.value)" v-on:change="Section.saveSectionData(section, 'video', $event.target.value)")
										option(:selected="!Object.values(videos).find(vid => `https://v-cdn.prvk.io/${vid.guid}/playlist.m3u8`) === section.Data.video" :value="'https://vz-3fc0db6e-ef5.b-cdn.net/ec7e5117-dd4d-4502-a414-53b01e969c03/playlist.m3u8'") Select video to show
										option(v-for="video in videos" :selected="section.Data.video===`https://v-cdn.prvk.io/${video.guid}/playlist.m3u8`" :value="`https://v-cdn.prvk.io/${video.guid}/playlist.m3u8`") {{video.title}}
								.section-settings.in-a-row
									small.left-title.text-muted URL
									textarea.full-width(v-on:input="setSectionData(section, 'video', $event.target.value)" v-on:change="Section.saveSectionData(section, 'video', $event.target.value)") {{section.Data.video}}
								.section-settings.in-a-row
									small.left-title.text-muted Override json key
									input.form-control.form-control-sm.full-width(type="text" v-on:input="setSectionData(section, 'override-json-key', $event.target.value)" v-on:change="Section.saveSectionData(section, 'override-json-key', $event.target.value)" :value="section.Data['override-json-key']")


						.section-settings-tab.section-type(v-if="section.Data.parent && section.template_id !== 6")
							.section-settings.in-a-row
								small.left-title.text-muted Section content
								select.right-control.custom-select.custom-select-sm.auto-width(v-on:input="setSectionType(section, $event.target.value)" v-on:change="Section.saveSectionType(section, $event.target.value)")
									option(:selected="section.type === 'image'" value="image") Image
									option(:selected="section.type === 'html'" value="html") HTML
									option(v-if="[3, 4].includes(section.template_id)" :selected="section.type === 'video'" value="video") YouTube
									option(v-if="[3, 4, 7].includes(section.template_id)" :selected="section.type === 'hls'" value="hls") Unbranded video
									option(v-if="[3, 4, 7].includes(section.template_id)" :selected="section.type === 'twitch'" value="twitch") Twitch
									option(v-if="[3, 4, 7].includes(section.template_id)" :selected="section.type === 'amazon'" value="amazon") Amazon
									option(v-if="[3, 4, 7].includes(section.template_id)" :selected="section.type === 'spotify'" value="spotify") Spotify
									option(v-if="[3, 4, 7].includes(section.template_id)" :selected="section.type === 'deezer'" value="deezer") Deezer
									option(v-if="[3, 5].includes(section.template_id)" :selected="section.type === 'playable'" value="playable") Playable

							.section-settings.in-a-row(v-if="section.type === 'playable'")
								small.left-title.text-muted Playable source
								input.form-control.form-control-sm.full-width(type="text" :value="section.Data['playable-code']" v-on:input="setSectionData(section, 'playable-code', $event.target.value)" v-on:change="Section.saveSectionData(section, 'playable-code', $event.target.value)")
							.section-settings.in-a-row(v-if="section.type === 'html'")
								small.left-title.text-muted HTML code
								textarea.full-width(v-on:input="setSectionData(section, 'html', $event.target.value)" v-on:change="Section.saveSectionData(section, 'html', $event.target.value)") {{section.Data.html}}
							.section-settings.in-a-row(v-if="section.type === 'video'")
								small.left-title.text-muted Youtube link
								input.form-control.form-control-sm.full-width(type="text" :value="section.Data['youtube']" v-on:input="setSectionData(section, 'youtube', $event.target.value)" v-on:change="Section.saveSectionData(section, 'youtube', $event.target.value)")
								//input.form-control.form-control-sm(v-on:input="setSectionData(section, 'youtube', $event.target.value)" v-on:change="Section.saveSectionData(section, 'youtube', $event.target.value)") {{section.Data.youtube}}
							.section-settings.in-a-row(v-if="section.type === 'hls'")
								small.left-title.text-muted Video
								select.right-control.custom-select.custom-select-sm.full-width(v-on:input="setSectionData(section, 'video', $event.target.value)" v-on:change="Section.saveSectionData(section, 'video', $event.target.value)")
									option(:selected="!Object.values(videos).find(vid => `https://v-cdn.prvk.io/${vid.guid}/playlist.m3u8`) === section.Data.video" :value="'https://vz-3fc0db6e-ef5.b-cdn.net/ec7e5117-dd4d-4502-a414-53b01e969c03/playlist.m3u8'") Select video to show
									option(v-for="video in videos" :selected="section.Data.video===`https://v-cdn.prvk.io/${video.guid}/playlist.m3u8`" :value="`https://v-cdn.prvk.io/${video.guid}/playlist.m3u8`") {{video.title}}
							.section-settings.in-a-row(v-if="section.type === 'hls'")
								small.left-title.text-muted URL
								textarea.full-width(v-on:input="setSectionData(section, 'video', $event.target.value)" v-on:change="Section.saveSectionData(section, 'video', $event.target.value)") {{section.Data.video}}

							.group(v-if="section.type === 'twitch'")
								.section-settings.in-a-row
									small.left-title.text-muted Content type
									select.right-control.custom-select.custom-select-sm(v-on:input="setSectionData(section, 'twitch-type', $event.target.value)" v-on:change="Section.saveSectionData(section, 'twitch-type', $event.target.value)")
										option(:selected="section.Data['twitch-type'] === 'channel'" value="channel") Channel
										option(:selected="section.Data['twitch-type'] === 'video'" value="video") Video
										option(:selected="section.Data['twitch-type '] === 'collection'" value="collection") Collection
								.section-settings.in-a-row
									small.left-title.text-muted {{section.Data['twitch-type'] || 'Channel'}}
									input.form-control.form-control-sm.full-width(type="text" :value="section.Data['twitch-content']" v-on:input="setSectionData(section, 'twitch-content', $event.target.value)" v-on:change="Section.saveSectionData(section, 'twitch-content', $event.target.value)")

							.group(v-if="section.type === 'amazon'")
								.section-settings.in-a-row
									small.left-title.text-muted IFrame id
									input.form-control.form-control-sm.full-width(type="text" :value="section.Data['amazon-id']" v-on:input="setSectionData(section, 'amazon-id', $event.target.value)" v-on:change="Section.saveSectionData(section, 'amazon-id', $event.target.value)")
								.section-settings.in-a-row
									small.left-title.text-muted Source
									input.form-control.form-control-sm.full-width(type="text" :value="section.Data['amazon-src']" v-on:input="setSectionData(section, 'amazon-src', $event.target.value)" v-on:change="Section.saveSectionData(section, 'amazon-src', $event.target.value)")
								.section-settings.in-a-row
									small.left-title.text-muted Style
									textarea.full-width(:value="section.Data['amazon-style']" v-on:input="setSectionData(section, 'amazon-style', $event.target.value)" v-on:change="Section.saveSectionData(section, 'amazon-style', $event.target.value)")

							.group(v-if="section.type === 'spotify'")
								.section-settings.in-a-row
									small.left-title.text-muted IFrame id
									input.form-control.form-control-sm.full-width(type="text" :value="section.Data['spotify-id'] || 'prvk-spotify-iframe'" v-on:input="setSectionData(section, 'spotify-id', $event.target.value)" v-on:change="Section.saveSectionData(section, 'spotify-id', $event.target.value)")
								.section-settings.in-a-row
									small.left-title.text-muted Source
									input.form-control.form-control-sm.full-width(type="text" :value="section.Data['spotify-src']" v-on:input="setSectionData(section, 'spotify-src', $event.target.value)" v-on:change="Section.saveSectionData(section, 'spotify-src', $event.target.value)")
								.section-settings.in-a-row
									small.left-title.text-muted Frame border
									input.form-control.form-control-sm.small-width(type="text" :value="section.Data['spotify-frameborder'] || '0'" v-on:input="setSectionData(section, 'spotify-frameborder', $event.target.value)" v-on:change="Section.saveSectionData(section, 'spotify-frameborder', $event.target.value)")

						.section-settings-tab(v-if="section.type === 'deezer'")

							.section-settings.in-a-row
								small.left-title.text-muted Content url
								input.form-control.form-control-sm.full-width(type="text" :value="section.Data['deezer-url']" v-on:input="setSectionData(section, 'deezer-url', $event.target.value)" v-on:change="Section.saveSectionData(section, 'deezer-url', $event.target.value)")

							.section-settings.in-a-row
								small.left-title.text-muted Theme
								select.right-control.custom-select.custom-select-sm.auto-widt(v-on:input="setSectionData(section, 'deezer-theme', $event.target.value)" v-on:change="Section.saveSectionData(section, 'deezer-theme', $event.target.value)")
									option(:selected="section.Data['deezer-theme'] === 'dark'" value="dark") Dark
									option(:selected="section.Data['deezer-theme'] === 'light'" value="light") Light
									option(:selected="section.Data['deezer-theme '] === 'auto'" value="auto") Auto

							.section-settings.in-a-row
								small.left-title.text-muted Auto width
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['deezer-autowidth']" @change="Section.saveSectionData(section, 'deezer-autowidth', $event.target.checked)")
									span.switch-slider(data-checked="ON" data-unchecked="OFF")
									span.switch-handle

							.section-settings.in-a-row
								small.left-title.text-muted Show Tracklist
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['deezer-tracklist']" @change="Section.saveSectionData(section, 'deezer-tracklist', $event.target.checked)")
									span.switch-slider(data-checked="ON" data-unchecked="OFF")
									span.switch-handle

						.section-settings-tab(v-if="section.Data.placement === 'fullscreen' && section.template_id === 3")
							.section-setting.in-a-row
								small.left-title.text-muted Change type on expand
								select.custom-select.custom-select-sm(v-on:input="setSectionData(section, 'change-type-on-expand', $event.target.value)" v-on:change="Section.saveSectionData(section, 'change-type-on-expand', $event.target.value)")
									option(:selected="!section.Data['change-type-on-expand'] ||section.Data['change-type-on-expand'] === 'none'" value="none") None
									option(:selected="section.Data['change-type-on-expand'] === 'playable'" value="playable") Playable

							.section-settings.in-a-row(v-if="section.Data['change-type-on-expand'] === 'playable'")
								small.left-title.text-muted Playable source
								input.form-control.form-control-sm.full-width(type="text" :value="section.Data['expanded-playable-code']" v-on:input="setSectionData(section, 'expanded-playable-code', $event.target.value)" v-on:change="Section.saveSectionData(section, 'expanded-playable-code', $event.target.value)")


						.section-settings-tab.dimensions-settings(v-if="section.Data.parent === 'body' && (section.template_id !== 6 || (section.template_id === 6 && (section.type === 'twitch' || section.type === 'hls')))")
							.section-setting.in-a-row(v-if="section.template_id !== 5 && section.template_id !== 6")
								small.left-title.text-muted Section placement
								select.custom-select.custom-select-sm(v-on:input="setSectionData(section, 'placement', $event.target.value)" v-on:change="Section.saveSectionData(section, 'placement', $event.target.value)")
									option(:selected="section.Data.placement === 'hybrid-banner'" value="hybrid-banner") Hybrid banner
									option(:selected="section.Data.placement === 'top'" value="top") Header
									option(:selected="section.Data.placement === 'left'" value="left") Content left
									option(:selected="section.Data.placement === 'right'" value="right") Content right
									option(:selected="section.Data.placement === 'fullscreen'" value="fullscreen") Fullscreen

							.section-settings.in-a-row(v-if="section.Data.placement !== 'fullscreen' && section.template_id !== 5 && section.template_id !== 6")
								small.left-title.text-muted Clickable area
								select.right-control.custom-select.custom-select-sm.auto-width(v-on:input="setSectionData(section, 'clickableArea', $event.target.value)" v-on:change="Section.saveSectionData(section, 'clickableArea', $event.target.value)")
									option(:selected="section.Data.clickableArea === 'content container'" value="content container") Content container
									option(:selected="section.Data.clickableArea === 'entire section'" value="entire section") Entire section

							.section-settings.in-a-row(v-if="(section.codename === 'top' || section.codename === 'left' || section.codename === 'right') && section.Data.clickableArea === 'entire section'")
								small.left-title.text-muted Top gap
								input.form-control.form-control-sm.small-width(type="number" placeholder="5" :value="section.Data['top-gap']" v-on:input="setSectionData(section, 'top-gap', $event.target.value)" v-on:change="Section.saveSectionData(section, 'top-gap', $event.target.value)")
							.section-settings.in-a-row(v-if="(section.codename === 'top' || section.codename === 'left' || section.codename === 'right') && section.Data.clickableArea === 'entire section'")
								small.left-title.text-muted Side gap
								input.form-control.form-control-sm.small-width(type="number" placeholder="5" :value="section.Data['side-gap']" v-on:input="setSectionData(section, 'side-gap', $event.target.value)" v-on:change="Section.saveSectionData(section, 'side-gap', $event.target.value)")
							.section-settings.in-a-row(v-if="(section.codename === 'top' || section.codename === 'left' || section.codename === 'right') && section.Data.clickableArea === 'entire section'")
								small.left-title.text-muted Content gap
								input.form-control.form-control-sm.small-width(type="number" placeholder="5" :value="section.Data['content-gap']" v-on:input="setSectionData(section, 'content-gap', $event.target.value)" v-on:change="Section.saveSectionData(section, 'content-gap', $event.target.value)")


							.section-settings.in-a-row(v-if="section.template_id === 5 && section.codename === 'top' && section.Data['spawn-as-overlay']")
								small.left-title.text-muted Section position
								select.right-control.custom-select.custom-select-sm(v-on:input="setSectionData(section, 'section-position', $event.target.value)" v-on:change="Section.saveSectionData(section, 'section-position', $event.target.value)")
									option(:selected="section.Data['section-position'] === 'top'" value="top") Top
									option(:selected="section.Data['section-position'] === 'bottom'" value="bottom") Bottom
							.section-settings.in-a-row(v-if="section.template_id === 5 && (section.codename === 'top' || section.codename === 'middle')")
								small.left-title.text-muted Spawn as overlay
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['spawn-as-overlay']" @change="Section.saveSectionData(section, 'spawn-as-overlay', $event.target.checked)")
									span.switch-slider(data-checked="ON" data-unchecked="OFF")
									span.switch-handle
							.section-settings.in-a-row(v-if="section.template_id === 5")
								small.left-title.text-muted Auto dimensions
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['auto-dimensions']" @change="Section.saveSectionData(section, 'auto-dimensions', $event.target.checked)")
									span.switch-slider(data-checked="ON" data-unchecked="OFF")
									span.switch-handle

							.section-settings.in-a-row(v-if="(section.template_id === 6) || (section.template_id === 5 && !section.Data['auto-dimensions']) || (section.template_id !== 5 && section.type !== 'video' && section.type !== 'hls' && section.type !== 'twitch')")
								small.left-title.text-muted Width
								input.form-control.form-control-sm.small-width(type="number" :value="section.Data.width" v-on:input="setSectionData(section, 'width', $event.target.value)" v-on:change="Section.saveSectionData(section, 'width', $event.target.value)")
								input.range.custom-range.margin-left.no-bg.full-width(type="range" :min="0" :max="3000" :stpe="1" :value="section.Data.width" v-on:input="onSizeInput('width', $event.target.value)" v-on:change="onSizeChanged('width', $event.target.value)")

							.section-settings.in-a-row(v-if="(section.template_id === 6) || (section.template_id === 5 && !section.Data['auto-dimensions']) || (section.template_id !== 5 && section.type !== 'video' && section.type !== 'hls' && section.type !== 'twitch')")
								small.left-title.text-muted Height
								input.form-control.form-control-sm.small-width(type="number" id="section-height" :value="section.Data.height" v-on:input="setSectionData(section, 'height', $event.target.value)" v-on:change="Section.saveSectionData(section, 'height', $event.target.value)")
								input.range.custom-range.margin-left.no-bg.full-width(type="range" :min="0" :max="3000" :stpe="1" :value="section.Data.height" v-on:input="onSizeInput('height', $event.target.value)" v-on:change="onSizeChanged('height', $event.target.value)")

							.section-settings.in-a-row(v-if="section.template_id === 6 && (section.type === 'twitch' || section.type === 'hls')")
								small.left-title.text-muted Mobile width
								input.form-control.form-control-sm.small-width(type="number" :value="section.Data['mobile-width'] || 200" v-on:input="setSectionData(section, 'mobile-width', $event.target.value)" v-on:change="Section.saveSectionData(section, 'mobile-width', $event.target.value)")
								input.range.custom-range.margin-left.no-bg.full-width(type="range" :min="0" :max="3000" :stpe="1" :value="section.Data['mobile-width']" v-on:input="onSizeInput('mobile-width', $event.target.value)" v-on:change="onSizeChanged('mobile-width', $event.target.value)")

							.section-settings.in-a-row(v-if="section.template_id === 6 && (section.type === 'twitch' || section.type === 'hls')")
								small.left-title.text-muted Mobile height
								input.form-control.form-control-sm.small-width(type="number" :value="section.Data['mobile-height'] || 113" v-on:input="setSectionData(section, 'mobile-height', $event.target.value)" v-on:change="Section.saveSectionData(section, 'mobile-height', $event.target.value)")
								input.range.custom-range.margin-left.no-bg.full-width(type="range" :min="0" :max="3000" :stpe="1" :value="section.Data['mobile-height']" v-on:input="onSizeInput('mobile-height', $event.target.value)" v-on:change="onSizeChanged('mobile-height', $event.target.value)")


							.calculate-size-button(v-if="section.type === 'html'" @click="calculateSize(section)")
								.btn.btn-sm.btn-block.btn-outline-secondary
									small.left-title Calculate size based on content

							.section-settings.in-a-row(v-if="section.type !== 'video' && section.type !== 'hls' && (section.Data.placement === 'left' || section.Data.placement === 'right')")
								small.left-title.text-muted Offset Y
								input.form-control.form-control-sm.small-width(type="number" id="section-offset-y" :value="section.Data.offsetY || 0" v-on:input="setSectionData(section, 'offsetY', $event.target.value)" v-on:change="Section.saveSectionData(section, 'offsetY', $event.target.value)")
								input.range.custom-range.margin-left.no-bg.full-width(type="range" :min="-150" :max="150" :stpe="0.5" :value="section.Data.offsetY || 0" v-on:input="onOffsetYInput($event.target.value)" v-on:change="onOffsetYChanged($event.target.value)")

							.section-settings.in-a-row(v-if="section.Data.placement === 'left' || section.Data.placement === 'right'")
								small.left-title.text-muted Placement style
								select.right-control.custom-select.custom-select-sm(v-on:input="setSectionData(section, 'placementStyle', $event.target.value)" v-on:change="Section.saveSectionData(section, 'placementStyle', $event.target.value)")
									option(:selected="section.Data.placementStyle === 'center'" value="center") Center
									option(:selected="section.Data.placementStyle === 'lock to content'" value="lock to content") Lock to content

							.section-settings.in-a-row(v-if="section.Data.placement === 'left' || section.Data.placement === 'right'")
								small.left-title.text-muted Responsive to zoom
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['responsive-to-zoom']" @change="Section.saveSectionData(section, 'responsive-to-zoom', $event.target.checked)")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle

							.section-settings.in-a-row(v-if="section.Data.placement === 'left' || section.Data.placement === 'right'")
								small.left-title.text-muted Minimal scale(%)
								input.form-control.form-control-sm.small-width(type="number" :value="section.Data.allowedReduction || 100" v-on:input="setSectionData(section, 'allowedReduction', $event.target.value)" v-on:change="Section.saveSectionData(section, 'allowedReduction', $event.target.value)")

						.section-settings-tab(v-if="(section.template_id === 3) && (section.Data.placement === 'left' || section.Data.placement === 'right')")
							.section-settings.in-a-row
								small.left-title.text-muted Keep position on expand
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['keep-position-on-expand']" @change="Section.saveSectionData(section, 'keep-position-on-expand', $event.target.checked)")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle

						.section-settings-tab(v-if="(section.template_id !== 7 && section.template_id !== 5 && section.template_id !== 6) && (section.Data.placement === 'left' || section.Data.placement === 'right')")
							.section-settings.in-a-row
								small.left-title.text-muted Change on scroll
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['change-on-scroll']" @change="Section.saveSectionData(section, 'change-on-scroll', $event.target.checked)")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle

							.section-settings.in-a-row(v-if="section.Data['change-on-scroll']")
								small.left-title.text-muted Changed asset
								select.right-control.custom-select.custom-select-sm(v-on:input="setSectionData(section, 'changed-asset', $event.target.value)" v-on:change="Section.saveSectionData(section, 'changed-asset', $event.target.value)")
									option(:selected="!section.Data['changed-asset']" :value="'no-changed-asset'") Select asset
									option(v-for="asset in Asset.AssetsByProject[section.project_id]" :selected="section.Data['changed-asset']===asset.codename" :value="asset.codename") {{asset.codename}}


						.section-settings-tab.stickiness-settings(v-if="section.template_id !== 6 && (section.Data.placement === 'left' || section.Data.placement === 'right')")
							.section-settings.in-a-row
								small.left-title.text-muted Remain sticky
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data.sticky" @change="Section.saveSectionData(section, 'sticky', $event.target.checked)")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle

							//.section-settings.in-a-row(v-if="section.Data.sticky")
								small.left-title.text-muted Stick to header
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data.stickToHeader" @change="Section.saveSectionData(section, 'stickToHeader', $event.target.checked)")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle

							.section-settings.in-a-row(v-if="section.Data.sticky")
								small.left-title.text-muted Stickiness top
								input.form-control.form-control-sm.small-width(type="number" :value="section.Data.stickinessTop || 100" v-on:input="setSectionData(section, 'stickinessTop', $event.target.value)" v-on:change="Section.saveSectionData(section, 'stickinessTop', $event.target.value)")

							.section-settings.in-a-row(v-if="section.Data.sticky")
								small.left-title.text-muted Allowed variation
								input.form-control.form-control-sm.small-width(type="number" :value="section.Data.allowedVariation || 200" v-on:input="setSectionData(section, 'allowedVariation', $event.target.value)" v-on:change="Section.saveSectionData(section, 'allowedVariation', $event.target.value)")

						.section-settings-tab(v-if="(section.template_id === 6 && section.codename !== 'twitch') || (section.template_id !== 5 && section.Data.parent === 'body' && (section.Data.placement !=='left' && section.Data.placement !== 'right'))")
							.position-settings
								.horizontal-part
									.section-x.in-a-row
										small.left-title.text-muted Offset X
										input.form-control.form-control-sm.small-width(type="number" step="0.001" :value="section.Data.offsetX || 0" v-on:input="setSectionData(section, 'offsetX', $event.target.value)" v-on:change="Section.saveSectionData(section, 'offsetX', $event.target.value)")
									.section-y.in-a-row
										small.left-title.text-muted Offset Y
										input.form-control.form-control-sm.small-width(type="number" step="0.001" :value="section.Data.offsetY || 0" v-on:input="setSectionData(section, 'offsetY', $event.target.value)" v-on:change="Section.saveSectionData(section, 'offsetY', $event.target.value)")
								.horizontal-part
									SettingControlCoordinates(:input="onOffsetInput" :changed="onOffsetChanged" :initialX="section.Data.offsetX || 0" :initialY="section.Data.offsetY || 0" :propertyName="'offset'")
								.horizontal-part
									SettingControlCoordinates(:input="onAnchorInput" :changed="onAnchorChanged" :initialX="section.Data.anchorX ? ((section.Data.anchorX - 0.5) * 2) : 0" :initialY="section.Data.anchorY ? ((section.Data.anchorY - 0.5) * 2) : 0" :propertyName="'anchor'")

						.section-settings-tab(v-if="(section.template_id === 6 && section.codename === 'twitch')")

							.section-settings.in-a-row
								small.left-title.text-muted Preview mobile position
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['preview-mobile-position']" @change="Section.saveSectionData(section, 'preview-mobile-position', $event.target.checked)")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle

							.position-settings
								.horizontal-part
									.section-x.in-a-row
										small.left-title.text-muted Mobile offset X
										input.form-control.form-control-sm.small-width(type="number" step="0.001" :value="section.Data.mOffsetX || 0" v-on:input="setSectionData(section, 'mOffsetX', $event.target.value)" v-on:change="Section.saveSectionData(section, 'mOffsetX', $event.target.value)")
									.section-y.in-a-row
										small.left-title.text-muted Mobile offset Y
										input.form-control.form-control-sm.small-width(type="number" step="0.001" :value="section.Data.mOffsetY || 0" v-on:input="setSectionData(section, 'mOffsetY', $event.target.value)" v-on:change="Section.saveSectionData(section, 'mOffsetY', $event.target.value)")
								.horizontal-part
									SettingControlCoordinates(:input="onOffsetInput" :changed="onOffsetChanged" :initialX="section.Data.mOffsetX || 0" :initialY="section.Data.mOffsetY || 0" :propertyName="'mOffset'")
								.horizontal-part
									SettingControlCoordinates(:input="onAnchorInput" :changed="onAnchorChanged" :initialX="section.Data.mAnchorX ? ((section.Data.mAnchorX - 0.5) * 2) : 0" :initialY="section.Data.mAnchorY ? ((section.Data.mAnchorY - 0.5) * 2) : 0" :propertyName="'mAnchor'")


						.section-settings-tab(v-if="section.template_id === 5 && section.codename === 'bottom'")
							.section-settings.in-a-row
								small.left-title.text-muted Sticky
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['sticky']" @change="Section.saveSectionData(section, 'sticky', $event.target.checked)")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle

						.section-settings-tab(v-if="section.template_id === 5")
							.section-settings.in-a-row
								small.left-title.text-muted Include embed
								select.right-control.custom-select.custom-select-sm(v-on:input="setSectionData(section, 'embed-type', $event.target.value)" v-on:change="Section.saveSectionData(section, 'embed-type', $event.target.value)" :style="{width: '130px'}")
									option(:selected="section.Data['embed-type'] === 'none'" value="none") None
									option(:selected="section.Data['embed-type'] === 'spotify'" value="spotify") Spotify
									option(:selected="section.Data['embed-type'] === 'amazon'" value="amazon") Amazon
									option(:selected="section.Data['embed-type'] === 'deezer'" value="deezer") Deezer
									option(:selected="section.Data['embed-type'] === 'html'" value="html") HTML

							//.section-settings.in-a-row(v-if="section.Data['embed-type'] === 'spotify'")
								small.left-title.text-muted IFrame id
								input.form-control.form-control-sm.full-width(type="text" :value="section.Data['spotify-id'] || 'prvk-spotify-iframe'" v-on:input="setSectionData(section, 'spotify-id', $event.target.value)" v-on:change="Section.saveSectionData(section, 'spotify-id', $event.target.value)")
							.section-settings.in-a-row(v-if="section.Data['embed-type'] === 'spotify'")
								small.left-title.text-muted Source
								input.form-control.form-control-sm.full-width(type="text" :value="section.Data['spotify-src']" v-on:input="setSectionData(section, 'spotify-src', $event.target.value)" v-on:change="Section.saveSectionData(section, 'spotify-src', $event.target.value)")
							.section-settings.in-a-row(v-if="section.Data['embed-type'] === 'spotify'")
								small.left-title.text-muted Frame border
								input.form-control.form-control-sm.small-width(type="text" :value="section.Data['spotify-frameborder'] || '0'" v-on:input="setSectionData(section, 'spotify-frameborder', $event.target.value)" v-on:change="Section.saveSectionData(section, 'spotify-frameborder', $event.target.value)")

							.section-settings.in-a-row(v-if="section.Data['embed-type'] === 'amazon'")
								small.left-title.text-muted Source
								input.form-control.form-control-sm.full-width(type="text" :value="section.Data['amazon-src']" v-on:input="setSectionData(section, 'amazon-src', $event.target.value)" v-on:change="Section.saveSectionData(section, 'amazon-src', $event.target.value)")
							.section-settings.in-a-row(v-if="section.Data['embed-type'] === 'amazon'")
								small.left-title.text-muted Style
								textarea.full-width(:value="section.Data['amazon-style']" v-on:input="setSectionData(section, 'amazon-style', $event.target.value)" v-on:change="Section.saveSectionData(section, 'amazon-style', $event.target.value)")

							.section-settings.in-a-row(v-if="section.Data['embed-type'] === 'deezer'")
								small.left-title.text-muted Content url
								input.form-control.form-control-sm.full-width(type="text" :value="section.Data['deezer-url']" v-on:input="setSectionData(section, 'deezer-url', $event.target.value)" v-on:change="Section.saveSectionData(section, 'deezer-url', $event.target.value)")

							.section-settings.in-a-row(v-if="section.Data['embed-type'] === 'deezer'")
								small.left-title.text-muted Theme
								select.right-control.custom-select.custom-select-sm.auto-widt(v-on:input="setSectionData(section, 'deezer-theme', $event.target.value)" v-on:change="Section.saveSectionData(section, 'deezer-theme', $event.target.value)")
									option(:selected="section.Data['deezer-theme'] === 'dark'" value="dark") Dark
									option(:selected="section.Data['deezer-theme'] === 'light'" value="light") Light
									option(:selected="section.Data['deezer-theme '] === 'auto'" value="auto") Auto

							.section-settings.in-a-row(v-if="section.Data['embed-type'] === 'deezer'")
								small.left-title.text-muted Show Tracklist
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['deezer-tracklist']" @change="Section.saveSectionData(section, 'deezer-tracklist', $event.target.checked)")
									span.switch-slider(data-checked="ON" data-unchecked="OFF")
									span.switch-handle

							.section-settings.in-a-row(v-if="section.Data['embed-type'] === 'html'")
								small.left-title.text-muted HTML text
								textarea.full-width(:value="section.Data['html-text']" v-on:input="setSectionData(section, 'html-text', $event.target.value)" v-on:change="Section.saveSectionData(section, 'html-text', $event.target.value)")

							.section-settings.in-a-row(v-if="section.Data['embed-type'] && section.Data['embed-type'] !== 'none'")
								small.left-title.text-muted Embed width (%)
								input.form-control.form-control-sm.small-width(type="number" :value="section.Data['embed-width'] || 100" v-on:input="setSectionData(section, 'embed-width', $event.target.value)" v-on:change="Section.saveSectionData(section, 'embed-width', $event.target.value)")

							.section-settings.in-a-row(v-if="section.Data['embed-type'] && section.Data['embed-type'] !== 'none'")
								small.left-title.text-muted Width/height ratio
								input.form-control.form-control-sm.small-width(type="number" :value="section.Data['embed-ratio'] || 1.75" v-on:input="setSectionData(section, 'embed-ratio', $event.target.value)" v-on:change="Section.saveSectionData(section, 'embed-ratio', $event.target.value)")


							.position-settings(v-if="section.Data['embed-type'] && section.Data['embed-type'] !== 'none'")
								.horizontal-part
									.section-x.in-a-row
										small.left-title.text-muted Offset X
										input.form-control.form-control-sm.small-width(type="number" step="0.001" :value="section.Data['embed-offsetX'] || 0" v-on:input="setSectionData(section, 'embed-offsetX', $event.target.value)" v-on:change="Section.saveSectionData(section, 'embed-offsetX', $event.target.value)")
									.section-y.in-a-row
										small.left-title.text-muted Offset Y
										input.form-control.form-control-sm.small-width(type="number" step="0.001" :value="section.Data['embed-offsetY'] || 0" v-on:input="setSectionData(section, 'embed-offsetY', $event.target.value)" v-on:change="Section.saveSectionData(section, 'embed-offsetY', $event.target.value)")
								.horizontal-part
									SettingControlCoordinates(:input="onOffsetInput" :changed="onOffsetChanged" :initialX="section.Data['embed-offsetX'] || 0" :initialY="section.Data['embed-offsetY'] || 0" :propertyName="'embed-offset'")
								.horizontal-part
									SettingControlCoordinates(:input="onAnchorInput" :changed="onAnchorChanged"  :initialX="section.Data['embed-anchorX'] ? ((section.Data['embed-anchorX'] - 0.5) * 2) : 0" :initialY="section.Data['embed-anchorY'] ? ((section.Data['embed-anchorY'] - 0.5) * 2) : 0" :propertyName="'embed-anchor'")


						.section-settings-tab(v-if="section.template_id === 5")
							.section-settings.in-a-row
								small.left-title.text-muted Include video
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['include-video']" @change="Section.saveSectionData(section, 'include-video', $event.target.checked)")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle

							.section-settings.in-a-row(v-if="section.Data['include-video']")
								small.left-title.text-muted Use YouTube video
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['use-youtube-video']" @change="Section.saveSectionData(section, 'use-youtube-video', $event.target.checked)")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle

							.section-settings.in-a-row(v-if="section.Data['include-video'] && section.Data['use-youtube-video']")
								small.left-title.text-muted YouTube video id
								input.form-control.form-control-sm.full-width(type="text" :value="section.Data['youtube-video-link']" v-on:input="setSectionData(section, 'youtube-video-link', $event.target.value)" v-on:change="Section.saveSectionData(section, 'youtube-video-link', $event.target.value)")


							.section-settings.in-a-row(v-if="section.Data['include-video'] && !section.Data['use-youtube-video']")
								small.left-title.text-muted Video
								select.right-control.custom-select.custom-select-sm.full-width(v-on:input="setSectionVideoForMobile(section, 'video', $event.target.value, $event.target.selectedOptions[0].text)" v-on:change="Section.saveSectionVideoForMobile(section, 'video', $event.target.value, $event.target.selectedOptions[0].text)")
									option(:selected="!Object.values(videos).find(vid => `https://v-cdn.prvk.io/${vid.guid}/playlist.m3u8`) === section.Data.video" :value="'https://vz-3fc0db6e-ef5.b-cdn.net/ec7e5117-dd4d-4502-a414-53b01e969c03/playlist.m3u8'") Select video to show
									option(v-for="video in videos" :selected="section.Data.video===`https://v-cdn.prvk.io/${video.guid}/playlist.m3u8`" :value="`https://v-cdn.prvk.io/${video.guid}/playlist.m3u8`") {{video.title}}
									//option(v-for="video in videos" :selected="section.Data.video===`https://v-cdn.prvk.io/${video.guid}/playlist.m3u8`" :value="`https://v-cdn.prvk.io/${video.guid}/playlist.m3u8`") {{video.title}}

							.section-settings.in-a-row(v-if="section.Data['include-video'] && section.Data['use-youtube-video']")
								small.left-title.text-muted Show controls
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['youtube-controls']" @change="Section.saveSectionData(section, 'youtube-controls', $event.target.checked)")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle

							.section-settings.in-a-row(v-if="section.Data['include-video']")
								small.left-title.text-muted Muted
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data.hasOwnProperty('muted') ? section.Data['muted'] : true" @change="Section.saveSectionData(section, 'muted', $event.target.checked)")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle

							.section-settings.in-a-row(v-if="section.Data['include-video']")
								small.left-title.text-muted Play on visible
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data.hasOwnProperty('play-on-visible') ? section.Data['play-on-visible'] : true" @change="Section.saveSectionData(section, 'play-on-visible', $event.target.checked)")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle

							.section-settings.in-a-row(v-if="section.Data['include-video']")
								small.left-title.text-muted Pause on hidden
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data.hasOwnProperty('pause-on-hidden') ? section.Data['pause-on-hidden'] : true" @change="Section.saveSectionData(section, 'pause-on-hidden', $event.target.checked)")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle

							.section-settings.in-a-row(v-if="section.Data['include-video']")
								small.left-title.text-muted Video width (%)
								input.form-control.form-control-sm.small-width(type="number" :value="section.Data['video-width'] || 100" v-on:input="setSectionData(section, 'video-width', $event.target.value)" v-on:change="Section.saveSectionData(section, 'video-width', $event.target.value)")

							.section-settings.in-a-row(v-if="section.Data['include-video'] && !section.Data['use-youtube-video']")
								small.left-title.text-muted Video background color
								input.form-control.form-control-sm(type="text" :value="section.Data['video-background-color'] || '#000000'" v-on:input="setSectionData(section, 'video-background-color', $event.target.value)" v-on:change="Section.saveSectionData(section, 'video-background-color', $event.target.value)" :style="{'width': '70px'}")
								input.form-control.form-control-sm(type="color" :value="section.Data['video-background-color'] || '#000000'" v-on:input="setSectionData(section, 'video-background-color', $event.target.value)" v-on:change="Section.saveSectionData(section, 'video-background-color', $event.target.value)" :style="{'width': '70px', 'margin-left': '10px'}")


							.position-settings(v-if="section.Data['include-video']")
								.horizontal-part
									.section-x.in-a-row
										small.left-title.text-muted Offset X
										input.form-control.form-control-sm.small-width(type="number" step="0.001" :value="section.Data['offsetX'] || 0" v-on:input="setSectionData(section, 'offsetX', $event.target.value)" v-on:change="Section.saveSectionData(section, 'offsetX', $event.target.value)")
									.section-y.in-a-row
										small.left-title.text-muted Offset Y
										input.form-control.form-control-sm.small-width(type="number" step="0.001" :value="section.Data['offsetY'] || 0" v-on:input="setSectionData(section, 'offsetY', $event.target.value)" v-on:change="Section.saveSectionData(section, 'offsetY', $event.target.value)")
								.horizontal-part
									SettingControlCoordinates(:input="onOffsetInput" :changed="onOffsetChanged" :initialX="section.Data['offsetX'] || 0" :initialY="section.Data.offsetY || 0" :propertyName="'offset'")
								.horizontal-part
									SettingControlCoordinates(:input="onAnchorInput" :changed="onAnchorChanged"  :initialX="section.Data.anchorX ? ((section.Data.anchorX - 0.5) * 2) : 0" :initialY="section.Data.anchorY ? ((section.Data.anchorY - 0.5) * 2) : 0" :propertyName="'anchor'")

						.section-settings-tab(v-if="section.template_id === 5")
							.section-settings.in-a-row
								small.left-title.text-muted Include twitch
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['include-twitch']" @change="Section.saveSectionData(section, 'include-twitch', $event.target.checked)")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle

							.section-settings.in-a-row(v-if="section.Data['include-twitch']")
								small.left-title.text-muted Content type
								select.right-control.custom-select.custom-select-sm(v-on:input="setSectionData(section, 'twitch-type', $event.target.value)" v-on:change="Section.saveSectionData(section, 'twitch-type', $event.target.value)" :style="{width: '130px'}")
									option(:selected="section.Data['twitch-type'] === 'channel'" value="channel") Channel
									option(:selected="section.Data['twitch-type'] === 'video'" value="video") Video
									option(:selected="section.Data['twitch-type '] === 'collection'" value="collection") Collection

							.section-settings.in-a-row(v-if="section.Data['include-twitch']")
								small.left-title.text-muted {{section.Data['twitch-type'] || 'Channel'}}
								input.form-control.form-control-sm.full-width(type="text" v-on:input="setSectionData(section, 'twitch-content', $event.target.value)" v-on:change="Section.saveSectionData(section, 'twitch-content', $event.target.value)" :value="section.Data['twitch-content']")

							.section-settings.in-a-row(v-if="section.Data['include-twitch']")
								small.left-title.text-muted Muted
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data.hasOwnProperty('muted') ? section.Data['muted'] : true" @change="Section.saveSectionData(section, 'muted', $event.target.checked)")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle

							.section-settings.in-a-row(v-if="section.Data['include-twitch']")
								small.left-title.text-muted Play on visible
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data.hasOwnProperty('play-on-visible') ? section.Data['play-on-visible'] : true" @change="Section.saveSectionData(section, 'play-on-visible', $event.target.checked)")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle

							.section-settings.in-a-row(v-if="section.Data['include-twitch']")
								small.left-title.text-muted Pause on hidden
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data.hasOwnProperty('pause-on-hidden') ? section.Data['pause-on-hidden'] : true" @change="Section.saveSectionData(section, 'pause-on-hidden', $event.target.checked)")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle

							.section-settings.in-a-row(v-if="section.Data['include-twitch']")
								small.left-title.text-muted Video width (%)
								input.form-control.form-control-sm.small-width(type="number" :value="section.Data['video-width'] || 100" v-on:input="setSectionData(section, 'video-width', $event.target.value)" v-on:change="Section.saveSectionData(section, 'video-width', $event.target.value)")


							.position-settings(v-if="section.Data['include-twitch']")
								.horizontal-part
									.section-x.in-a-row
										small.left-title.text-muted Offset X
										input.form-control.form-control-sm.small-width(type="number" step="0.001" :value="section.Data['offsetX'] || 0" v-on:input="setSectionData(section, 'offsetX', $event.target.value)" v-on:change="Section.saveSectionData(section, 'offsetX', $event.target.value)")
									.section-y.in-a-row
										small.left-title.text-muted Offset Y
										input.form-control.form-control-sm.small-width(type="number" step="0.001" :value="section.Data['offsetY'] || 0" v-on:input="setSectionData(section, 'offsetY', $event.target.value)" v-on:change="Section.saveSectionData(section, 'offsetY', $event.target.value)")
								.horizontal-part
									SettingControlCoordinates(:input="onOffsetInput" :changed="onOffsetChanged" :initialX="section.Data['offsetX'] || 0" :initialY="section.Data.offsetY || 0" :propertyName="'offset'")
								.horizontal-part
									SettingControlCoordinates(:input="onAnchorInput" :changed="onAnchorChanged" :initialX="section.Data['anchorX'] ? ((section.Data['anchorX'] - 0.5) * 2) : 0" :initialY="section.Data['anchorY'] ? ((section.Data['anchorY'] - 0.5) * 2) : 0" :propertyName="'anchor'")


						.section-settings-tab(v-if="section.codename === 'middle'")
							.section-settings.in-a-row
								small.left-title.text-muted Disable parallax
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['disable-parallax']" @change="Section.saveSectionData(section, 'disable-parallax', $event.target.checked)")
									span.switch-slider(data-checked="ON" data-unchecked="OFF")
									span.switch-handle

						.section-settings-tab(v-if="section.codename === 'middle'")
							.section-settings.in-a-row
								small.left-title.text-muted Special type
								select.right-control.custom-select.custom-select-sm.auto-width(v-on:input="setSectionData(section, 'special-type', $event.target.value)" v-on:change="Section.saveSectionData(section, 'special-type', $event.target.value)")
									option(:selected="section.Data['special-type'] === 'none' || !section.Data['special-type']" value="none") None
									option(:selected="section.Data['special-type'] === 'image-gallery'" value="image-gallery") Image gallery
									option(:selected="section.Data['special-type'] === 'video'" value="video") Video
									option(:selected="section.Data['special-type'] === 'swiper'" value="swiper") Swiper
									option(:selected="section.Data['special-type'] === 'flipbook'" value="flipbook") Flipbook
							//.section-settings.in-a-row
								small.left-title.text-muted Image gallery
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['image-gallery']" @change="Section.saveSectionData(section, 'image-gallery', $event.target.checked)")
									span.switch-slider(data-checked="ON" data-unchecked="OFF")
									span.switch-handle

							.section-settings.in-a-row(v-if="section.Data['special-type'] === 'image-gallery'")
								small.left-title.text-muted Number of images
								input.form-control.form-control-sm.small-width(type="number" :value="section.Data['image-gallery-images']" v-on:input="setSectionData(section, 'image-gallery-images', $event.target.value)" v-on:change="Section.saveSectionData(section, 'image-gallery-images', $event.target.value)")

							.section-settings.in-a-row(v-if="section.Data['special-type'] === 'image-gallery'")
								small.left-title.text-muted Image fit
								select.right-control.custom-select.custom-select-sm.auto-width(v-on:input="setSectionData(section, 'image-gallery-fit', $event.target.value)" v-on:change="Section.saveSectionData(section, 'image-gallery-fit', $event.target.value)")
									option(:selected="section.Data['image-gallery-fit'] === 'contain'" value="contain") Fit to screen
									option(:selected="section.Data['image-gallery-fit'] === 'cover'" value="cover") Cover screen

							.section-settings.in-a-row(v-if="section.Data['special-type'] === 'image-gallery'")
								small.left-title.text-muted Interval (ms)
								input.form-control.form-control-sm.small-width(type="number" :placeholder="'4000'" :value="section.Data['image-gallery-interval']" v-on:input="setSectionData(section, 'image-gallery-interval', $event.target.value)" v-on:change="Section.saveSectionData(section, 'image-gallery-interval', $event.target.value)")

							.section-settings.in-a-row(v-if="section.Data['special-type'] === 'image-gallery'")
								small.left-title.text-muted Use overlay
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['image-gallery-overlay']" @change="Section.saveSectionData(section, 'image-gallery-overlay', $event.target.checked)")
									span.switch-slider(data-checked="ON" data-unchecked="OFF")
									span.switch-handle
							.section-settings.in-a-row(v-if="section.Data['special-type'] === 'image-gallery' && section.Data['image-gallery-overlay']")
								small.left-title.text-muted Overlay image
								select.right-control.custom-select.custom-select-sm.auto-width(v-on:input="setSectionData(section, 'image-gallery-overlay-image', $event.target.value)" v-on:change="Section.saveSectionData(section, 'image-gallery-overlay-image', $event.target.value)" :style="{width: '130px'}")
									option(:selected="!section.Data['image-gallery-overlay-image']" :value="'none'") No
									option(v-for="asset in Asset.AssetsByProject[section.project_id]" :selected="section.Data['image-gallery-overlay-image']===asset.codename" :value="asset.codename") {{asset.codename}}

							.section-settings.in-a-row(v-if="section.Data['special-type'] === 'video'")
								small.left-title.text-muted Video asset
								select.right-control.custom-select.custom-select-sm.full-width(v-on:input="setSectionVideoForMobile(section, 'video-asset', $event.target.value, $event.target.selectedOptions[0].text)" v-on:change="Section.saveSectionVideoForMobile(section, 'video-asset', $event.target.value, $event.target.selectedOptions[0].text)")
									option(:selected="!Object.values(videos).find(vid => `https://v-cdn.prvk.io/${vid.guid}/playlist.m3u8`) === section.Data['video-asset']" :value="'https://vz-3fc0db6e-ef5.b-cdn.net/ec7e5117-dd4d-4502-a414-53b01e969c03/playlist.m3u8'") Select video to show
									option(v-for="video in videos" :selected="section.Data['video-asset']===`https://v-cdn.prvk.io/${video.guid}/playlist.m3u8`" :value="`https://v-cdn.prvk.io/${video.guid}/playlist.m3u8`") {{video.title}}
							.section-settings.in-a-row(v-if="section.Data['special-type'] === 'video'")
								small.left-title.text-muted Image fit
								select.right-control.custom-select.custom-select-sm.auto-width(v-on:input="setSectionData(section, 'video-fit', $event.target.value)" v-on:change="Section.saveSectionData(section, 'video-fit', $event.target.value)")
									option(:selected="section.Data['video-fit'] === 'contain'" value="contain") Fit to screen
									option(:selected="section.Data['video-fit'] === 'cover'" value="cover") Cover screen
							.section-settings.in-a-row(v-if="section.Data['special-type'] === 'video'")
								small.left-title.text-muted Use overlay
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['video-overlay']" @change="Section.saveSectionData(section, 'video-overlay', $event.target.checked)")
									span.switch-slider(data-checked="ON" data-unchecked="OFF")
									span.switch-handle
							.section-settings.in-a-row(v-if="section.Data['special-type'] === 'video' && section.Data['video-overlay']")
								small.left-title.text-muted Overlay image
								select.right-control.custom-select.custom-select-sm.auto-width(v-on:input="setSectionData(section, 'video-overlay-image', $event.target.value)" v-on:change="Section.saveSectionData(section, 'video-overlay-image', $event.target.value)" :style="{width: '130px'}")
									option(:selected="!section.Data['video-overlay-image']" :value="'none'") No
									option(v-for="asset in Asset.AssetsByProject[section.project_id]" :selected="section.Data['video-overlay-image']===asset.codename" :value="asset.codename") {{asset.codename}}

							.section-settings.in-a-row(v-if="section.Data['special-type'] === 'swiper'")
								small.left-title.text-muted Main banner fit
								select.right-control.custom-select.custom-select-sm.auto-width(v-on:input="setSectionData(section, 'swiper-fit', $event.target.value)" v-on:change="Section.saveSectionData(section, 'swiper-fit', $event.target.value)")
									option(:selected="section.Data['swiper-fit'] === 'cover'" value="cover") Cover screen
									option(:selected="section.Data['swiper-fit'] === 'contain'" value="contain") Fit to screen

							.section-settings.in-a-row(v-if="section.Data['special-type'] === 'swiper'")
								small.left-title.text-muted Swiper images
								ListGroupControl(:section="section" :settingName="'swiper-images'" :settingValue="section.Data['swiper-images']" :type="'assets'")


							.section-settings.in-a-row(v-if="section.Data['special-type'] === 'flipbook'")
								small.left-title.text-muted Flipbook behaviour
								select.right-control.custom-select.custom-select-sm.auto-width(v-on:input="setSectionData(section, 'flipbook-behaviour', $event.target.value)" v-on:change="Section.saveSectionData(section, 'flipbook-behaviour', $event.target.value)")
									option(:selected="section.Data['flipbook-behaviour'] === 'bottom'" value="bottom") Bottom main frame
									option(:selected="section.Data['flipbook-behaviour'] === 'middle'" value="middle") Middle main frame

							.section-settings.in-a-row(v-if="section.Data['special-type'] === 'flipbook'")
								small.left-title.text-muted Number of frames
								input.form-control.form-control-sm.small-width(type="number" :value="section.Data['flipbook-frames']" v-on:input="setSectionData(section, 'flipbook-frames', $event.target.value)" v-on:change="Section.saveSectionData(section, 'flipbook-frames', $event.target.value)")

							.section-settings.in-a-row(v-if="section.Data['special-type'] === 'flipbook'")
								small.left-title.text-muted Use overlay
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['flipbook-overlay']" @change="Section.saveSectionData(section, 'flipbook-overlay', $event.target.checked)")
									span.switch-slider(data-checked="ON" data-unchecked="OFF")
									span.switch-handle
							.section-settings.in-a-row(v-if="section.Data['special-type'] === 'flipbook' && section.Data['flipbook-overlay']")
								small.left-title.text-muted Overlay image
								select.right-control.custom-select.custom-select-sm.auto-width(v-on:input="setSectionData(section, 'flipbook-overlay-image', $event.target.value)" v-on:change="Section.saveSectionData(section, 'flipbook-overlay-image', $event.target.value)" :style="{width: '130px'}")
									option(:selected="!section.Data['flipbook-overlay-image']" :value="'none'") No
									option(v-for="asset in Asset.AssetsByProject[section.project_id]" :selected="section.Data['flipbook-overlay-image']===asset.codename" :value="asset.codename") {{asset.codename}}


						.section-settings-tab(v-if="section.codename === 'middle'")
							.section-settings.in-a-row
								small.left-title.text-muted Text above
								input.form-control.form-control-sm.full-width(type="text" :value="section.Data['text-above'] || 'ADVERTISEMENT'" v-on:input="setSectionData(section, 'text-above', $event.target.value)" v-on:change="Section.saveSectionData(section, 'text-above', $event.target.value)")

							.section-settings.in-a-row
								small.left-title.text-muted Font size
								input.form-control.form-control-sm.small-width(type="number" :value="section.Data['text-above-size'] || 16" v-on:input="setSectionData(section, 'text-above-size', $event.target.value)" v-on:change="Section.saveSectionData(section, 'text-above-size', $event.target.value)")

							.section-settings.in-a-row
								small.left-title.text-muted Font color
								input.form-control.form-control-sm(type="text" :value="section.Data['text-above-color'] || '#ffffff'" v-on:input="setSectionData(section, 'text-above-color', $event.target.value)" v-on:change="Section.saveSectionData(section, 'text-above-color', $event.target.value)" :style="{'width': '70px'}")
								input.form-control.form-control-sm(type="color" :value="section.Data['text-above-color'] || '#ffffff'" v-on:input="setSectionData(section, 'text-above-color', $event.target.value)" v-on:change="Section.saveSectionData(section, 'text-above-color', $event.target.value)" :style="{'width': '70px', 'margin-left': '10px'}")

							.section-settings.in-a-row
								small.left-title.text-muted Background color
								input.form-control.form-control-sm(type="text" :value="section.Data['text-above-background'] || '#000000'" v-on:input="setSectionData(section, 'text-above-background', $event.target.value)" v-on:change="Section.saveSectionData(section, 'text-above-background', $event.target.value)" :style="{'width': '70px'}")
								input.form-control.form-control-sm(type="color" :value="section.Data['text-above-background'] || '#000000'" v-on:input="setSectionData(section, 'text-above-background', $event.target.value)" v-on:change="Section.saveSectionData(section, 'text-above-background', $event.target.value)" :style="{'width': '70px', 'margin-left': '10px'}")

						.section-settings-tab(v-if="section.codename === 'middle'")
							.section-settings.in-a-row
								small.left-title.text-muted Text below
								input.form-control.form-control-sm.full-width(type="text" :value="section.Data['text-below'] || 'Scroll to more'" v-on:input="setSectionData(section, 'text-below', $event.target.value)" v-on:change="Section.saveSectionData(section, 'text-below', $event.target.value)")

							.section-settings.in-a-row
								small.left-title.text-muted Font size
								input.form-control.form-control-sm.small-width(type="number" :value="section.Data['text-below-size'] || 16" v-on:input="setSectionData(section, 'text-below-size', $event.target.value)" v-on:change="Section.saveSectionData(section, 'text-below-size', $event.target.value)")

							.section-settings.in-a-row
								small.left-title.text-muted Font color
								input.form-control.form-control-sm(type="text" :value="section.Data['text-below-color'] || '#ffffff'" v-on:input="setSectionData(section, 'text-below-color', $event.target.value)" v-on:change="Section.saveSectionData(section, 'text-below-color', $event.target.value)" :style="{'width': '70px'}")
								input.form-control.form-control-sm(type="color" :value="section.Data['text-below-color'] || '#ffffff'" v-on:input="setSectionData(section, 'text-below-color', $event.target.value)" v-on:change="Section.saveSectionData(section, 'text-below-color', $event.target.value)" :style="{'width': '70px', 'margin-left': '10px'}")

							.section-settings.in-a-row
								small.left-title.text-muted Background color
								input.form-control.form-control-sm(type="text" :value="section.Data['text-below-background'] || '#000000'" v-on:input="setSectionData(section, 'text-below-background', $event.target.value)" v-on:change="Section.saveSectionData(section, 'text-below-background', $event.target.value)" :style="{'width': '70px'}")
								input.form-control.form-control-sm(type="color" :value="section.Data['text-below-background'] || '#000000'" v-on:input="setSectionData(section, 'text-below-background', $event.target.value)" v-on:change="Section.saveSectionData(section, 'text-below-background', $event.target.value)" :style="{'width': '70px', 'margin-left': '10px'}")

						.section-settings-tab(v-if="section.template_id === 7 && section.codename === 'top'")

							.section-settings.in-a-row
								small.left-title.text-muted Development mode
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['dev-mode']" @change="Section.saveSectionData(section, 'dev-mode', $event.target.checked)")
									span.switch-slider(data-checked="ON" data-unchecked="OFF")
									span.switch-handle

							.section-settings.in-a-row
								small.left-title.text-muted Toggle on
								select.right-control.custom-select.custom-select-sm(v-on:input="setSectionData(section, `toggle-mode`, $event.target.value)" v-on:change="Section.saveSectionData(section, `toggle-mode`, $event.target.value)")
									option(:selected="section.Data['toggle-mode'] === 'click'" value="click") Click
									option(:selected="section.Data['toggle-mode'] === 'hover'" value="hover") Hover

							.section-settings.in-a-row
								small.left-title.text-muted Default background
								select.right-control.custom-select.custom-select-sm(v-on:input="setSectionData(section, `default-bg`, $event.target.value)" v-on:change="Section.saveSectionData(section, `default-bg`, $event.target.value)")
									option(v-for="asset in Asset.AssetsByProject[section.project_id]" :selected="section.Data[`default-bg`]===asset.codename" :value="asset.codename") {{asset.codename}}

							.section-settings.in-a-row
								small.left-title.text-muted Toggle count
								input.form-control.form-control-sm.small-width(type="number" :value="section.Data['toggle-count'] || 5" v-on:input="setSectionData(section, 'toggle-count', $event.target.value)" v-on:change="Section.saveSectionData(section, 'toggle-count', $event.target.value)")
							.section-settings.in-a-row
								small.left-title.text-muted Toggle start
								input.form-control.form-control-sm.small-width(type="number" placeholder="445" :value="section.Data['toggle-start']" v-on:input="setSectionDataInstantly(section, 'toggle-start', $event.target.value)" v-on:change="Section.saveSectionData(section, 'toggle-start', $event.target.value)")
							.section-settings.in-a-row
								small.left-title.text-muted Toggle bottom height
								input.form-control.form-control-sm.small-width(type="number" placeholder="40" :value="section.Data['toggle-bottom']" v-on:input="setSectionDataInstantly(section, 'toggle-bottom', $event.target.value)" v-on:change="Section.saveSectionData(section, 'toggle-bottom', $event.target.value)")

							.section-settings-tab(v-for="index in (section.Data['toggle-count'] ? parseInt(section.Data['toggle-count']) : 5)")
								.section-settings.in-a-row
									small.left-title.text-muted {{'Segment ' + index + ' background'}}
									select.right-control.custom-select.custom-select-sm(v-on:input="setSectionData(section, `segment-${index - 1}-bg`, $event.target.value)" v-on:change="Section.saveSectionData(section, `segment-${index - 1}-bg`, $event.target.value)")
										option(v-for="asset in Asset.AssetsByProject[section.project_id]" :selected="section.Data[`segment-${index - 1}-bg`]===asset.codename" :value="asset.codename") {{asset.codename}}
								.section-settings.in-a-row
									small.left-title.text-muted {{'Segment ' + index + ' background color'}}
									input.form-control.form-control-sm.default-width(type="color" :value="section.Data[`segment-${index - 1}-bg-color`] || '#ffffff'" v-on:input="setSectionData(section, `segment-${index - 1}-bg-color`, $event.target.value)" v-on:change="Section.saveSectionData(section, `segment-${index - 1}-bg-color`, $event.target.value)")
									span(v-on:click="getBackgroundColor(section, index - 1)" :style="{'margin-left': '10px', 'cursor': 'pointer'}")
										i.additional-input-button.fa.fa-square-o(v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Get color from border of a background image'}")

						.section-settings-tab(v-if="section.template_id !== 7 && section.template_id !== 6 && section.template_id !== 5 && section.Data.parent")
							.section-settings.in-a-row
								small.left-title.text-muted Visual effect
								select.right-control.custom-select.custom-select-sm(v-on:input="setSectionData(section, 'visual-effect', $event.target.value)" v-on:change="Section.saveSectionData(section, 'visual-effect', $event.target.value)")
									option(:selected="section.Data['visual-effect'] === 'none'" value="none") None
									option(:selected="section.Data['visual-effect'] === 'glow'" value="glow") Glow
									option(:selected="section.Data['visual-effect'] === 'jump'" value="jump") Jump
									option(:selected="section.Data['visual-effect'] === 'blink'" value="blink") Blink
									option(:selected="section.Data['visual-effect'] === 'wiggle'" value="wiggle") Wiggle
									option(:selected="section.Data['visual-effect'] === 'custom'" value="custom") Custom

							.section-settings.in-a-row(v-if="section.template_id !== 5 && section.template_id !== 6 && section.Data['visual-effect'] && section.Data['visual-effect'] !== 'none'")
								small.left-title.text-muted Apply on hover
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['apply-on-hover']" @change="Section.saveSectionData(section, 'apply-on-hover', $event.target.checked)")
									span.switch-slider(data-checked="ON" data-unchecked="OFF")
									span.switch-handle

							.section-settings.in-a-row(v-if="section.Data['visual-effect'] && section.Data['visual-effect'] !== 'none'")
								small.left-title.text-muted Visual effect style
								textarea.full-width.text-area-disabled(v-on:input="setSectionData(section, 'visual-effect-css', $event.target.value)" :disabled="section.Data['visual-effect']!=='custom'" v-on:change="Section.saveSectionData(section, 'visual-effect-css', $event.target.value)") {{getSectionVisualEffectCss(section)}}



						.section-settings-tab(v-if="(section.type === 'twitch' || section.type === 'hls') && section.template_id === 6")
							.section-settings.in-a-row(v-if="section.type === 'twitch'")
								small.left-title.text-muted Use iframe code
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['twitch-use-iframe']" @change="Section.saveSectionData(section, 'twitch-use-iframe', $event.target.checked)")
									span.switch-slider(data-checked="ON" data-unchecked="OFF")
									span.switch-handle

							.section-settings.in-a-row(v-if="section.type === 'twitch'")
								small.left-title.text-muted Spawn in tag parent
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['spawn-in-tag-parent']" @change="Section.saveSectionData(section, 'spawn-in-tag-parent', $event.target.checked)")
									span.switch-slider(data-checked="ON" data-unchecked="OFF")
									span.switch-handle

							.section-settings.in-a-row
								small.left-title.text-muted Hide bottom overlay
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['hide-bottom-overlay']" @change="Section.saveSectionData(section, 'hide-bottom-overlay', $event.target.checked)")
									span.switch-slider(data-checked="ON" data-unchecked="OFF")
									span.switch-handle

							.section-settings.in-a-row
								small.left-title.text-muted Hide close button
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['hide-close-button']" @change="Section.saveSectionData(section, 'hide-close-button', $event.target.checked)")
									span.switch-slider(data-checked="ON" data-unchecked="OFF")
									span.switch-handle


						.section-settings-tab(v-if="(section.type === 'twitch' && !section.Data['twitch-use-iframe']) || section.type === 'hls'")

							.section-settings.in-a-row(v-if="section.type === 'twitch'")
								small.left-title.text-muted Show overlay on hover
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['twitch-overlay-enabled']" @change="Section.saveSectionData(section, 'twitch-overlay-enabled', $event.target.checked)")
									span.switch-slider(data-checked="ON" data-unchecked="OFF")
									span.switch-handle

							.section-settings.in-a-row(v-if="section.type === 'twitch'")
								small.left-title.text-muted Overlay text
								input.form-control.form-control-sm.full-width(type="text" :value="section.Data['twitch-text']" v-on:input="setSectionData(section, 'twitch-text', $event.target.value)" v-on:change="Section.saveSectionData(section, 'twitch-text', $event.target.value)")

							.section-settings.in-a-row(v-if="section.type === 'twitch'")
								small.left-title.text-muted Clickout url
								input.form-control.form-control-sm.full-width(type="text" :value="section.Data['twitch-clickout']" v-on:input="setSectionData(section, 'twitch-clickout', $event.target.value)" v-on:change="Section.saveSectionData(section, 'twitch-clickout', $event.target.value)")


							.section-settings.in-a-row(v-if="section.type === 'twitch'")
								small.left-title.text-muted Delay before spawn
								input.form-control.form-control-sm.small-width(type="number" :value="section.Data['twitch-delay']" v-on:input="setSectionData(section, 'twitch-delay', $event.target.value)" v-on:change="Section.saveSectionData(section, 'twitch-delay', $event.target.value)")

							.section-settings.in-a-row
								small.left-title.text-muted Autoplay
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['twitch-autoplay']" @change="Section.saveSectionData(section, 'twitch-autoplay', $event.target.checked)")
									span.switch-slider(data-checked="ON" data-unchecked="OFF")
									span.switch-handle

							.section-settings.in-a-row(v-if="section.type === 'twitch'")
								small.left-title.text-muted Disable autoplay in Chrome
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['disable-twitch-chrome-autoplay']" @change="Section.saveSectionData(section, 'disable-twitch-chrome-autoplay', $event.target.checked)")
									span.switch-slider(data-checked="ON" data-unchecked="OFF")
									span.switch-handle

							.section-settings.in-a-row
								small.left-title.text-muted Muted
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['twitch-muted']" @change="Section.saveSectionData(section, 'twitch-muted', $event.target.checked)")
									span.switch-slider(data-checked="ON" data-unchecked="OFF")
									span.switch-handle

							.section-settings.in-a-row(v-if="section.type === 'twitch'")
								small.left-title.text-muted Show player controls
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['show-twitch-controls']" @change="Section.saveSectionData(section, 'show-twitch-controls', $event.target.checked)")
									span.switch-slider(data-checked="ON" data-unchecked="OFF")
									span.switch-handle

							.section-settings.in-a-row(v-if="playerStyle === 'docked-player'")
								small.left-title.text-muted Bottom border height(%)
								input.form-control.form-control-sm.small-width(type="number" :value="section.Data['bottom-border-height'] || 30" v-on:input="setSectionData(section, 'bottom-border-height', $event.target.value)" v-on:change="Section.saveSectionData(section, 'bottom-border-height', $event.target.value)")

							.section-settings.in-a-row(v-if="playerStyle === 'docked-player'")
								small.left-title.text-muted Bottom border height(%) mobile
								input.form-control.form-control-sm.small-width(type="number" :value="section.Data['bottom-border-height-mobile'] || 30" v-on:input="setSectionData(section, 'bottom-border-height-mobile', $event.target.value)" v-on:change="Section.saveSectionData(section, 'bottom-border-height-mobile', $event.target.value)")


							.section-settings.in-a-row(v-if="playerStyle === 'docked-player'")
								small.left-title.text-muted Corner radius
								input.form-control.form-control-sm.small-width(type="number" :value="section.Data['bottom-border-corner-radius'] || 40" v-on:input="setSectionData(section, 'bottom-border-corner-radius', $event.target.value)" v-on:change="Section.saveSectionData(section, 'bottom-border-corner-radius', $event.target.value)")

							.section-settings.in-a-row(v-if="playerStyle === 'docked-player'")
								small.left-title.text-muted Corner radius mobile
								input.form-control.form-control-sm.small-width(type="number" :value="section.Data['bottom-border-corner-radius-mobile'] || 40" v-on:input="setSectionData(section, 'bottom-border-corner-radius-mobile', $event.target.value)" v-on:change="Section.saveSectionData(section, 'bottom-border-corner-radius-mobile', $event.target.value)")

							.section-settings.in-a-row(v-if="playerStyle === 'docked-player'")
								small.left-title.text-muted Bottom border color
								input.form-control.form-control-sm(type="text" :value="section.Data['bottom-border-color'] || '#9147ff'" v-on:input="setSectionData(section, 'bottom-border-color', $event.target.value)" v-on:change="Section.saveSectionData(section, 'bottom-border-color', $event.target.value)" :style="{'width': '70px'}")
								input.form-control.form-control-sm(type="color" :value="section.Data['bottom-border-color'] || '#9147ff'" v-on:input="setSectionData(section, 'bottom-border-color', $event.target.value)" v-on:change="Section.saveSectionData(section, 'bottom-border-color', $event.target.value)" :style="{'width': '70px', 'margin-left': '10px'}")

							.section-settings.in-a-row(v-if="playerStyle === 'docked-player'")
								small.left-title.text-muted Extra text
								input.form-control.form-control-sm.full-width(type="text" :value="section.Data['twitch-extra-text'] || 'Watch on Twitch'" v-on:input="setSectionData(section, 'twitch-extra-text', $event.target.value)" v-on:change="Section.saveSectionData(section, 'twitch-extra-text', $event.target.value)")

							.section-settings.in-a-row(v-if="playerStyle === 'docked-player'")
								small.left-title.text-muted Extra text size
								input.form-control.form-control-sm.small-width(type="number" :value="section.Data['twitch-extra-text-size'] || 24" v-on:input="setSectionData(section, 'twitch-extra-text-size', $event.target.value)" v-on:change="Section.saveSectionData(section, 'twitch-extra-text-size', $event.target.value)")

							.section-settings.in-a-row(v-if="playerStyle === 'docked-player'")
								small.left-title.text-muted Extra text size mobile
								input.form-control.form-control-sm.small-width(type="number" :value="section.Data['twitch-extra-text-size-mobile'] || 24" v-on:input="setSectionData(section, 'twitch-extra-text-size-mobile', $event.target.value)" v-on:change="Section.saveSectionData(section, 'twitch-extra-text-size-mobile', $event.target.value)")


							.section-settings.in-a-row(v-if="playerStyle === 'docked-player'")
								small.left-title.text-muted Extra text color
								input.form-control.form-control-sm(type="text" :value="section.Data['twitch-extra-text-color'] || '#ffffff'" v-on:input="setSectionData(section, 'twitch-extra-text-color', $event.target.value)" v-on:change="Section.saveSectionData(section, 'twitch-extra-text-color', $event.target.value)" :style="{'width': '70px'}")
								input.form-control.form-control-sm(type="color" :value="section.Data['twitch-extra-text-color'] || '#ffffff'" v-on:input="setSectionData(section, 'twitch-extra-text-color', $event.target.value)" v-on:change="Section.saveSectionData(section, 'twitch-extra-text-color', $event.target.value)" :style="{'width': '70px', 'margin-left': '10px'}")

							.section-settings.in-a-row
								small.left-title.text-muted Display profile icon
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data.hasOwnProperty('display-profile-icon') ? section.Data['display-profile-icon'] : true" @change="Section.saveSectionData(section, 'display-profile-icon', $event.target.checked)")
									span.switch-slider(data-checked="ON" data-unchecked="OFF")
									span.switch-handle

							.section-settings.in-a-row
								small.left-title.text-muted Display chat icon
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data.hasOwnProperty('display-chat-icon') ? section.Data['display-chat-icon'] : true" @change="Section.saveSectionData(section, 'display-chat-icon', $event.target.checked)")
									span.switch-slider(data-checked="ON" data-unchecked="OFF")
									span.switch-handle

							.section-settings.in-a-row
								small.left-title.text-muted Display splitter
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data.hasOwnProperty('display-splitter') ? section.Data['display-splitter'] : true" @change="Section.saveSectionData(section, 'display-splitter', $event.target.checked)")
									span.switch-slider(data-checked="ON" data-unchecked="OFF")
									span.switch-handle

							.section-settings.in-a-row
								small.left-title.text-muted Display Twitch icon
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data.hasOwnProperty('display-twitch-icon') ? section.Data['display-twitch-icon'] : true" @change="Section.saveSectionData(section, 'display-twitch-icon', $event.target.checked)")
									span.switch-slider(data-checked="ON" data-unchecked="OFF")
									span.switch-handle

						.section-settings-tab(v-if="(section.type === 'spotify' || section.type === 'amazon' || section.type === 'deezer') && section.template_id === 7")
							.section-settings.in-a-row
								small.left-title.text-muted Width
								input.form-control.form-control-sm.small-width(type="number" :value="section.Data.width || 445" v-on:input="setSectionData(section, 'width', $event.target.value)" v-on:change="Section.saveSectionData(section, 'width', $event.target.value)")

							.section-settings.in-a-row
								small.left-title.text-muted Height
								input.form-control.form-control-sm.small-width(type="number" :value="section.Data.height || 250" v-on:input="setSectionData(section, 'height', $event.target.value)" v-on:change="Section.saveSectionData(section, 'height', $event.target.value)")

						.section-settings-tab(v-if="section.template_id === 3 && (section.type === 'video' || section.type === 'hls' || section.type === 'twitch')")
							.section-settings.in-a-row
								small.left-title.text-muted Consider headers on expand
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['consider-headers-on-expand']" @change="Section.saveSectionData(section, 'consider-headers-on-expand', $event.target.checked)")
									span.switch-slider(data-checked="ON" data-unchecked="OFF")
									span.switch-handle

							.section-settings.in-a-row
								small.left-title.text-muted Keep background image position on expand
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['keep-background-position-on-expand']" @change="Section.saveSectionData(section, 'keep-background-position-on-expand', $event.target.checked)")
									span.switch-slider(data-checked="ON" data-unchecked="OFF")
									span.switch-handle

						.section-settings-tab(v-if="(section.type === 'video' || section.type === 'hls' || section.type === 'twitch' || section.type === 'html' || section.type === 'playable') && (section.Data.placement === 'fullscreen' || section.template_id === 7)")
							.section-settings.in-a-row(v-if="section.template_id !== 7")
								small.left-title.text-muted Start collapsed
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['start-collapsed']" @change="Section.saveSectionData(section, 'start-collapsed', $event.target.checked)")
									span.switch-slider(data-checked="ON" data-unchecked="OFF")
									span.switch-handle

							.section-settings.in-a-row(v-if="section.type === 'hls' && section.template_id !== 7")
								small.left-title.text-muted Expanded size
								.btn-group.btn-group-toggle(data-toogle="buttons" v-on:input="pressButton(section, $event)")
									label.btn.btn-secondary(v-bind:class="{ active: section.Data.videoSizeMode === 'fixed' || !section.Data.videoSizeMode}") Fixed size
										input(type="radio" name="options" id="btn-fixed-size" autocomplete="off")
									label.btn.btn-secondary(v-bind:class="{ active: section.Data.videoSizeMode === 'ratio'}") Fixed ratio
										input(type="radio" name="options" id="btn-fixed-ratio" autocomplete="off")
							.section-settings.in-a-row(v-if="section.template_id === 7")
								small.left-title.text-muted Width
								input.form-control.form-control-sm.small-width(type="number" :value="section.Data.width || 445" v-on:input="setSectionData(section, 'width', $event.target.value)" v-on:change="Section.saveSectionData(section, 'width', $event.target.value)")

							.section-settings.in-a-row(v-if="section.template_id === 7")
								small.left-title.text-muted Height
								input.form-control.form-control-sm.small-width(type="number" :value="section.Data.height || 250" v-on:input="setSectionData(section, 'height', $event.target.value)" v-on:change="Section.saveSectionData(section, 'height', $event.target.value)")

							.section-settings.in-a-row(v-if="section.template_id !== 7")
								small.left-title.text-muted Width
								input.form-control.form-control-sm.small-width(v-if="section.Data.videoSizeMode === 'fixed'" type="number" :value="section.Data.width" v-on:input="setSectionData(section, 'width', $event.target.value)" v-on:change="Section.saveSectionData(section, 'width', $event.target.value)")
								input.form-control.form-control-sm.small-width(v-else type="number" :value="section.Data.widthRatio" v-on:input="setSectionData(section, 'widthRatio', $event.target.value)" v-on:change="Section.saveSectionData(section, 'widthRatio', $event.target.value)")

							.section-settings.in-a-row(v-if="section.template_id !== 7")
								small.left-title.text-muted Height
								input.form-control.form-control-sm.small-width(v-if="section.Data.videoSizeMode === 'fixed'" type="number" :value="section.Data.height" v-on:input="setSectionData(section, 'height', $event.target.value)" v-on:change="Section.saveSectionData(section, 'height', $event.target.value)")
								input.form-control.form-control-sm.small-width(v-else type="number" :value="section.Data.heightRatio" v-on:input="setSectionData(section, 'heightRatio', $event.target.value)" v-on:change="Section.saveSectionData(section, 'heightRatio', $event.target.value)")

							.section-settings.in-a-row(v-if="section.template_id !== 7")
								small.left-title.text-muted Bottom border
								input.form-control.form-control-sm.small-width(type="number" :value="section.Data.bottomBorder || 200" v-on:input="setSectionData(section, 'bottomBorder', $event.target.value)" v-on:change="Section.saveSectionData(section, 'bottomBorder', $event.target.value)")

							.section-settings.in-a-row(v-if="section.template_id !== 7")
								small.left-title.text-muted Collapsed width
								input.form-control.form-control-sm.small-width(type="number" :value="section.Data.collapsedWidth || 300" v-on:input="setSectionData(section, 'collapsedWidth', $event.target.value)" v-on:change="Section.saveSectionData(section, 'collapsedWidth', $event.target.value)")

							.section-settings.in-a-row(v-if="section.template_id !== 7")
								small.left-title.text-muted Collapsed height
								input.form-control.form-control-sm.small-width(type="number" :value="section.Data.collapsedHeight || 200" v-on:input="setSectionData(section, 'collapsedHeight', $event.target.value)" v-on:change="Section.saveSectionData(section, 'collapsedHeight', $event.target.value)")

							.position-settings(v-if="section.template_id !== 7")
								.horizontal-part
									.section-x.in-a-row
										small.left-title.text-muted Collapsed offset X
										input.form-control.form-control-sm.small-width(type="number" step="0.001" :value="section.Data.collapsedOffsetX || 0" v-on:input="setSectionData(section, 'collapsedOffsetX', $event.target.value)" v-on:change="Section.saveSectionData(section, 'collapsedOffsetX', $event.target.value)")
									.section-y.in-a-row
										small.left-title.text-muted Collapsed offset Y
										input.form-control.form-control-sm.small-width(type="number" step="0.001" :value="section.Data.collapsedOffsetY || 0" v-on:input="setSectionData(section, 'collapsedOffsetY', $event.target.value)" v-on:change="Section.saveSectionData(section, 'collapsedOffsetY', $event.target.value)")
								.horizontal-part
									SettingControlCoordinates(:input="onCollapsedOffsetInput" :changed="onCollapsedOffsetChanged" :initialX="section.Data.collapsedOffsetX || 0" :initialY="section.Data.collapsedOffsetY || 0")
								.horizontal-part
									SettingControlCoordinates(:input="onCollapsedAnchorInput" :changed="onCollapsedAnchorChanged" :initialX="(section.Data.collapsedAnchorX - 0.5) * 2 || 0" :initialY="(section.Data.collapsedAnchorY - 0.5) * 2 || 0")

							.section-settings.in-a-row(v-if="section.type === 'hls'")
								small.left-title.text-muted Show PLAY/PAUSE button
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['show-play-button']" @change="Section.saveSectionData(section, 'show-play-button', $event.target.checked)")
									span.switch-slider(data-checked="ON" data-unchecked="OFF")
									span.switch-handle

							.section-settings.in-a-row(v-if="section.type === 'hls'")
								small.left-title.text-muted Show MUTE/UNMUTE button
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['show-mute-button']" @change="Section.saveSectionData(section, 'show-mute-button', $event.target.checked)")
									span.switch-slider(data-checked="ON" data-unchecked="OFF")
									span.switch-handle

							.section-settings.in-a-row(v-if="section.type === 'hls'")
								small.left-title.text-muted Play sound on hover
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['play-sound-on-hover']" @change="Section.saveSectionData(section, 'play-sound-on-hover', $event.target.checked)")
									span.switch-slider(data-checked="ON" data-unchecked="OFF")
									span.switch-handle

							.section-settings.in-a-row(v-if="section.type === 'hls' || section.type === 'video'")
								small.left-title.text-muted Loop video
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['loop-video']" @change="Section.saveSectionData(section, 'loop-video', $event.target.checked)")
									span.switch-slider(data-checked="ON" data-unchecked="OFF")
									span.switch-handle

							.section-settings.in-a-row(v-if="section.type === 'hls' || section.type === 'video'")
								small.left-title.text-muted Play on load
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['play-on-load']" @change="Section.saveSectionData(section, 'play-on-load', $event.target.checked)")
									span.switch-slider(data-checked="ON" data-unchecked="OFF")
									span.switch-handle

							.section-settings.in-a-row(v-if="section.type === 'hls'")
								small.left-title.text-muted Hide background color
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['hide-background-color']" @change="Section.saveSectionData(section, 'hide-background-color', $event.target.checked)")
									span.switch-slider(data-checked="ON" data-unchecked="OFF")
									span.switch-handle

							.section-settings.in-a-row(v-if="section.type === 'video'")
								small.left-title.text-muted Muted
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['yt-muted']" @change="Section.saveSectionData(section, 'yt-muted', $event.target.checked)")
									span.switch-slider(data-checked="ON" data-unchecked="OFF")
									span.switch-handle

							.section-settings.in-a-row(v-if="section.type === 'hls'")
								small.left-title.text-muted Controls color
								input.form-control.form-control-sm(type="text" :value="section.Data['controls-color'] || '#ffffff'" v-on:input="setSectionData(section, 'controls-color', $event.target.value)" v-on:change="Section.saveSectionData(section, 'controls-color', $event.target.value)" :style="{'width': '70px'}")
								input.form-control.form-control-sm(type="color" :value="section.Data['controls-color'] || '#ffffff'" v-on:input="setSectionData(section, 'controls-color', $event.target.value)" v-on:change="Section.saveSectionData(section, 'controls-color', $event.target.value)" :style="{'margin-left': '10px', 'width': '70px'}")


							.section-settings.in-a-row(v-if="section.type === 'hls' && section.template_id !== 7")
								small.left-title.text-muted Controls horizontal spacing
								input.form-control.form-control-sm.small-width(type="text" :value="section.Data['horizontal-spacing'] || 5" v-on:input="setSectionData(section, 'horizontal-spacing', $event.target.value)" v-on:change="Section.saveSectionData(section, 'horizontal-spacing', $event.target.value)")

							.section-settings.in-a-row(v-if="section.type === 'hls' && section.template_id !== 7")
								small.left-title.text-muted Controls vertical spacing
								input.form-control.form-control-sm.small-width(type="text" :value="section.Data['vertical-spacing'] || 5" v-on:input="setSectionData(section, 'vertical-spacing', $event.target.value)" v-on:change="Section.saveSectionData(section, 'vertical-spacing', $event.target.value)")



						.section-settings-tab(v-if="section.template_id !== 7 && section.template_id !== 6 && (section.type === 'hls' || section.type === 'twitch')")
							.section-settings.in-a-row
								small.left-title.text-muted Move to fixed
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['move-to-fixed']" @change="Section.saveSectionData(section, 'move-to-fixed', $event.target.checked)")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle

							.position-settings(v-if="section.Data['move-to-fixed']")
								.horizontal-part
									.section-x.in-a-row
										small.left-title.text-muted Fixed offset X
										input.form-control.form-control-sm.small-width(type="number" step="0.001" :value="section.Data.fixedOffsetX || 0" v-on:input="setSectionData(section, 'fixedOffsetX', $event.target.value)" v-on:change="Section.saveSectionData(section, 'fixedOffsetX', $event.target.value)")
									.section-y.in-a-row
										small.left-title.text-muted Fixed offset Y
										input.form-control.form-control-sm.small-width(type="number" step="0.001" :value="section.Data.fixedOffsetY || 0" v-on:input="setSectionData(section, 'fixedOffsetY', $event.target.value)" v-on:change="Section.saveSectionData(section, 'fixedOffsetY', $event.target.value)")
								.horizontal-part
									SettingControlCoordinates(:input="onFixedOffsetInput" :changed="onFixedOffsetChanged" :initialX="section.Data.fixedOffsetX || 0" :initialY="section.Data.fixedOffsetY || 0")
								.horizontal-part
									SettingControlCoordinates(:input="onFixedAnchorInput" :changed="onFixedAnchorChanged" :initialX="(section.Data.fixedAnchorX - 0.5) * 2 || 0" :initialY="(section.Data.fixedAnchorY - 0.5) * 2 || 0")

						.section-settings-tab(v-if="'spawn-on-hover' in section.Data")
							.section-settings.in-a-row
								small.left-title.text-muted Spawn on hover
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['spawn-on-hover']" @change="Section.saveSectionData(section, 'spawn-on-hover', $event.target.checked)")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle
							.section-settings.in-a-row
								small.left-title.text-muted Spawn on click
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['spawn-on-click']" @change="Section.saveSectionData(section, 'spawn-on-click', $event.target.checked)")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle

							small.left-title.text-muted Spawn sections
							.aside-settings
								SpawnSectionsList(:setting="section")

						.section-settings-tab(v-if="section.Data['spawn-on-hover'] === true")
							.section-settings.in-a-row(v-if="section.Data['display-hover-timer'] === true")
								small.left-title.text-muted Hover area
								select.right-control.custom-select.custom-select-sm(v-on:input="setSectionData(section, 'hover-area', $event.target.value)" v-on:change="Section.saveSectionData(section, 'hover-area', $event.target.value)")
									option(:selected="section.Data[\"hover-area\"] === 'section'" value="section") Section
									option(:selected="section.Data[\"hover-area\"] === 'video'" value="video") Video
							.section-settings.in-a-row
								small.left-title.text-muted Display hover timer
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['display-hover-timer']" @change="Section.saveSectionData(section, 'display-hover-timer', $event.target.checked)")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle
							.section-settings.in-a-row(v-if="section.Data['display-hover-timer'] === true")
								small.left-title.text-muted Delay before timer appear
								input.right-control.form-control.form-control-sm(type="text" :value="section.Data['hover-timer-delay']" placeholder="" v-on:input="setSectionData(section, 'hover-timer-delay', $event.target.value)" v-on:change="Section.saveSectionData(section, 'hover-timer-delay', $event.target.value)")
							.section-settings.in-a-row(v-if="section.Data['display-hover-timer'] === true")
								small.left-title.text-muted Timer opacity
								input.right-control.form-control.form-control-sm(type="text" :value="section.Data['hover-timer-opacity']" placeholder="" v-on:input="setSectionData(section, 'hover-timer-opacity', $event.target.value)" v-on:change="Section.saveSectionData(section, 'hover-timer-opacity', $event.target.value)")

						.delete-section-button(v-if="section.Data.newTitle" @click="deleteSection(section.id)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, html: true}")
							.btn.btn-sm.btn-block.btn-outline-danger
								small.left-title Remove section

					.interstitial-section(v-if="section.type === 'interstitial' && section.codename !== 'background'")
						.section-settings-tab
							.section-settings.in-a-row
								small.left-title.text-muted Number of screens
								input.right-control.form-control.form-control-sm.small-width(type="text" :value="section.Data.numberOfScreens || 4" placeholder="4" v-on:input="setSectionData(section, 'numberOfScreens', $event.target.value)" v-on:change="Section.saveSectionData(section, 'numberOfScreens', $event.target.value)")

							.section-settings.in-a-row
								small.left-title.text-muted Navigation styling
								select.right-control.custom-select.custom-select-sm.default-width(v-on:input="setSectionData(section, 'navigation-styling', $event.target.value)" v-on:change="Section.saveSectionData(section, 'navigation-styling', $event.target.value)")
									option(:selected="section.Data[\"navigation-styling\"] === 'image'" value="image") Image
									option(:selected="section.Data[\"navigation-styling\"] === 'text'" value="text") Text

							.section-settings.in-a-row(v-if="section.Data['navigation-styling'] === 'text'" v-for="index in (section.Data.numberOfScreens ? parseInt(section.Data.numberOfScreens) : 4)")
								small.left-title.text-muted {{'Screen ' + index + ' name'}}
								input.right-control.form-control.form-control-sm.default-width(type="text" :value="section.Data[`screen-${index-1}`]" :placeholder="`Screen ${index}`" v-on:input="setSectionData(section, `screen-${index-1}`, $event.target.value)" v-on:change="Section.saveSectionData(section, `screen-${index-1}`, $event.target.value)")

							.section-settings.in-a-row
								small.left-title.text-muted Top nav offset (%)
								input.right-control.form-control.form-control-sm.small-width(type="text" :value="section.Data['top-nav-offset']" placeholder="5" v-on:input="setSectionData(section, 'top-nav-offset', $event.target.value)" v-on:change="Section.saveSectionData(section, 'top-nav-offset', $event.target.value)")

						.section-settings-tab
							.section-settings.in-a-row
								small.left-title.text-muted Include video
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['include-video']" @change="Section.saveSectionData(section, 'include-video', $event.target.checked)")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle

							.section-settings.in-a-row(v-if="section.Data['include-video']")
								small.left-title.text-muted Screen with video
								select.right-control.custom-select.custom-select-sm.defalt-width(v-on:input="setSectionData(section, 'video-screen', $event.target.value)" v-on:change="Section.saveSectionData(section, 'video-screen', $event.target.value)")
									option(v-for="screen in interstitialScreens" :selected="section.Data['video-screen']===screen" :value="screen") {{screen}}

							.section-settings.in-a-row(v-if="section.Data['include-video']")
								small.left-title.text-muted Video
								select.right-control.custom-select.custom-select-sm.full-width(v-on:input="setSectionData(section, 'video', $event.target.value)" v-on:change="Section.saveSectionData(section, 'video', $event.target.value)" :style="{width: '200px'}")
									option(:selected="!Object.values(videos).find(vid => `https://v-cdn.prvk.io/${vid.guid}/playlist.m3u8`) === section.Data.video" :value="'https://vz-3fc0db6e-ef5.b-cdn.net/ec7e5117-dd4d-4502-a414-53b01e969c03/playlist.m3u8'") Select video to show
									option(v-for="video in videos" :selected="section.Data.video===`https://v-cdn.prvk.io/${video.guid}/playlist.m3u8`" :value="`https://v-cdn.prvk.io/${video.guid}/playlist.m3u8`") {{video.title}}

							.section-settings.in-a-row(v-if="section.Data['include-video']")
								small.left-title.text-muted Width
								input.form-control.form-control-sm.small-width.small-width(type="number" :value="section.Data.width || 768" v-on:input="setSectionData(section, 'width', $event.target.value)" v-on:change="Section.saveSectionData(section, 'width', $event.target.value)")

							.section-settings.in-a-row(v-if="section.Data['include-video']")
								small.left-title.text-muted Height
								input.form-control.form-control-sm.small-width(type="number" :value="section.Data.height || 432" v-on:input="setSectionData(section, 'height', $event.target.value)" v-on:change="Section.saveSectionData(section, 'height', $event.target.value)")

							.position-settings(v-if="section.Data['include-video']")
								.horizontal-part
									.section-x.in-a-row
										small.left-title.text-muted Offset X
										input.form-control.form-control-sm(type="number" step="0.001" :value="section.Data.offsetX || 0" v-on:input="setSectionData(section, 'offsetX', $event.target.value)" v-on:change="Section.saveSectionData(section, 'offsetX', $event.target.value)" :style="{width: '60px'}")
									.section-y.in-a-row
										small.left-title.text-muted Offset Y
										input.form-control.form-control-sm(type="number" step="0.001" :value="section.Data.offsetY || 0" v-on:input="setSectionData(section, 'offsetY', $event.target.value)" v-on:change="Section.saveSectionData(section, 'offsetY', $event.target.value)" :style="{width: '60px'}")
								.horizontal-part
									SettingControlCoordinates(:input="onOffsetInput" :changed="onOffsetChanged" :initialX="section.Data.offsetX || 0" :initialY="section.Data.offsetY || 0" :propertyName="'offset'")
								.horizontal-part
									SettingControlCoordinates(:input="onAnchorInput" :changed="onAnchorChanged" :initialX="section.Data.anchorX ? ((section.Data.anchorX - 0.5) * 2) : 0" :initialY="section.Data.anchorY ? ((section.Data.anchorY - 0.5) * 2) : 0" :propertyName="'anchor'")

						.section-settings-tab
							.section-settings.in-a-row
								small.left-title.text-muted Image gallery
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['include-gallery']" @change="Section.saveSectionData(section, 'include-gallery', $event.target.checked)")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle

							.section-settings.in-a-row(v-if="section.Data['include-gallery']")
								small.left-title.text-muted Display images
								select.right-control.custom-select.custom-select-sm.auto-width(v-on:input="setSectionData(section, 'gallery-fit', $event.target.value)" v-on:change="Section.saveSectionData(section, 'gallery-fit', $event.target.value)")
									option(:selected="section.Data['gallery-fit'] === 'cover'" value="cover") Cover screen
									option(:selected="section.Data['gallery-fit'] === 'contain'" value="contain") Fit to screen

							.section-settings.in-a-row(v-if="section.Data['include-gallery']")
								small.left-title.text-muted Screen with gallery
								select.right-control.custom-select.custom-select-sm.default-width(v-on:input="setSectionData(section, 'gallery-screen', $event.target.value)" v-on:change="Section.saveSectionData(section, 'gallery-screen', $event.target.value)")
									option(v-for="screen in interstitialScreens" :selected="section.Data['gallery-screen']===screen" :value="screen") {{screen}}

							.section-settings.in-a-row(v-if="section.Data['include-gallery']")
								small.left-title.text-muted Number of images
								input.form-control.form-control-sm.small-width(type="number" :value="section.Data['number-of-images']" :placeholder='2' v-on:input="setSectionData(section, 'number-of-images', $event.target.value)" v-on:change="Section.saveSectionData(section, 'number-of-images', $event.target.value)" :style="{width: '60px'}")

						.section-settings-tab
							.section-settings.in-a-row
								small.left-title.text-muted Poll
								label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="section.Data['include-poll']" @change="Section.saveSectionData(section, 'include-poll', $event.target.checked)")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle

							.section-settings.in-a-row(v-if="section.Data['include-poll']")
								small.left-title.text-muted Screen with poll
								select.right-control.custom-select.custom-select-sm.default-width(v-on:input="setSectionData(section, 'poll-screen', $event.target.value)" v-on:change="Section.saveSectionData(section, 'poll-screen', $event.target.value)")
									option(v-for="screen in interstitialScreens" :selected="section.Data['poll-screen']===screen" :value="screen") {{screen}}

							.section-settings.in-a-row(v-if="section.Data['include-poll']")
								small.left-title.text-muted Number of variants
								input.form-control.form-control-sm.small-width(type="number" :value="section.Data['number-of-variants']" :placeholder='"2"' v-on:input="setSectionData(section, 'number-of-variants', $event.target.value)" v-on:change="Section.saveSectionData(section, 'number-of-variants', $event.target.value)")

							.section-settings.in-a-row(v-if="section.Data['include-poll']")
								small.left-title.text-muted Font size
								input.form-control.form-control-sm.small-width(type="number" :value="section.Data['poll-font-size']" :placeholder='"60"' v-on:input="setSectionData(section, 'poll-font-size', $event.target.value)" v-on:change="Section.saveSectionData(section, 'poll-font-size', $event.target.value)")

							.section-settings.in-a-row(v-if="section.Data['include-poll']")
								small.left-title.text-muted Poll opacity
								input.form-control.form-control-sm.small-width(type="number" :value="section.Data.hasOwnProperty('poll-opacity') ? section.Data['poll-opacity'] : 100" :placeholder='"100"' v-on:input="setSectionData(section, 'poll-opacity', $event.target.value)" v-on:change="Section.saveSectionData(section, 'poll-opacity', $event.target.value)")

							.section-settings.in-a-row
								.position-settings
									.horizontal-part
										.section-x.in-a-row
											small.left-title.text-muted Offset X
											input.form-control.form-control-sm(type="number" step="0.001" :value="section.Data['pollOffsetX'] || 0" v-on:input="setSectionData(section, 'pollOffsetX', $event.target.value)" v-on:change="Section.saveSectionData(section, 'pollOffsetX', $event.target.value)" :style="{width: '60px'}")
										.section-y.in-a-row
											small.left-title.text-muted Offset Y
											input.form-control.form-control-sm(type="number" step="0.001" :value="section.Data['pollOffsetY'] || 0" v-on:input="setSectionData(section, 'pollOffsetY', $event.target.value)" v-on:change="Section.saveSectionData(section, 'pollOffsetY', $event.target.value)" :style="{width: '60px'}")
									.horizontal-part
										SettingControlCoordinates(:input="onOffsetInput" :changed="onOffsetChanged" :initialX="section.Data.pollOffsetX || 0" :initialY="section.Data.pollOffsetY || 0" :propertyName="'pollOffset'")
									.horizontal-part
										SettingControlCoordinates(:input="onAnchorInput" :changed="onAnchorChanged" :initialX="section.Data.pollAnchorX ? ((section.Data.pollAnchorX - 0.5) * 2) : 0" :initialY="section.Data.pollAnchorY ? ((section.Data.pollAnchorY - 0.5) * 2) : 0" :propertyName="'pollAnchor'")

						.section-settings-tab(v-for="index in (section.Data['number-of-variants'] ? parseInt(section.Data['number-of-variants']) : 2)" v-if="section.Data['include-poll']")
							.section-settings.in-a-row
								small.left-title.text-muted {{'Button ' + index + ' text'}}
								input.right-control.form-control.form-control-sm.default-width(type="text" :value="section.Data[`button-${index-1}-text`]" :placeholder="`Button ${index}`" v-on:input="setSectionData(section, `button-${index-1}-text`, $event.target.value)" v-on:change="Section.saveSectionData(section, `button-${index-1}-text`, $event.target.value)")
							.section-settings.in-a-row
								small.left-title.text-muted {{'Button ' + index + ' color'}}
								input.form-control.form-control-sm(type="text" :value="section.Data[`button-${index-1}-color`] || '#ffffff'" v-on:input="setSectionData(section, `button-${index-1}-color`, $event.target.value)" v-on:change="Section.saveSectionData(section, `button-${index-1}-color`, $event.target.value)" :style="{'width': '70px'}")
								input.form-control.form-control-sm(type="color" :value="section.Data[`button-${index-1}-color`] || '#ffffff'" v-on:input="setSectionData(section, `button-${index-1}-color`, $event.target.value)" v-on:change="Section.saveSectionData(section, `button-${index-1}-color`, $event.target.value)" :style="{'width': '70px', 'margin-left': '10px'}")
							.section-settings.in-a-row
								small.left-title.text-muted {{'Button ' + index + ' text color'}}
								input.form-control.form-control-sm(type="text" :value="section.Data[`button-${index-1}-text-color`] || '#000000'" v-on:input="setSectionData(section, `button-${index-1}-text-color`, $event.target.value)" v-on:change="Section.saveSectionData(section, `button-${index-1}-text-color`, $event.target.value)" :style="{'width': '70px'}")
								input.form-control.form-control-sm(type="color" :value="section.Data[`button-${index-1}-text-color`] || '#000000'" v-on:input="setSectionData(section, `button-${index-1}-text-color`, $event.target.value)" v-on:change="Section.saveSectionData(section, `button-${index-1}-text-color`, $event.target.value)" :style="{'width': '70px', 'margin-left': '10px'}")
							.section-settings.in-a-row
								small.left-title.text-muted Change background
								select.right-control.custom-select.custom-select-sm.auto-width(v-on:input="setSectionData(section, `button-${index}-selected-bg`, $event.target.value)" v-on:change="Section.saveSectionData(section, `button-${index}-selected-bg`, $event.target.value)" :style="{width: '130px'}")
									option(:selected="!section.Data[`button-${index}-selected-bg`]" :value="'none'") No
									option(v-for="asset in Asset.AssetsByProject[section.project_id]" :selected="section.Data[`button-${index}-selected-bg`]===asset.codename" :value="asset.codename") {{asset.codename}}
							.section-settings.in-a-row
								small.left-title.text-muted {{'Button ' + index + ' width'}}
								input.right-control.form-control.form-control-sm.small-width(type="text" :value="section.Data[`button-${index-1}-width`]" :placeholder="`auto`" v-on:input="setSectionData(section, `button-${index-1}-width`, $event.target.value)" v-on:change="Section.saveSectionData(section, `button-${index-1}-width`, $event.target.value)")
							.section-settings.in-a-row
								small.left-title.text-muted {{'Button ' + index + ' height'}}
								input.right-control.form-control.form-control-sm.small-width(type="text" :value="section.Data[`button-${index-1}-height`]" :placeholder="`auto`" v-on:input="setSectionData(section, `button-${index-1}-height`, $event.target.value)" v-on:change="Section.saveSectionData(section, `button-${index-1}-height`, $event.target.value)")
				.section-list-item-settings.new-settings(v-else-if="expandedSectionId === section.id && (section.template_id === 8 || section.template_id === 10 || section.template_id === 9 || section.template_id === 11)")

					.section-settings.in-a-row(v-for="setting in templateSettings")
						.condition-wrapper(v-if="checkConditions(section, setting) && setting.control !== 'tab-wrapper' && setting.template_id === section.template_id" :class="{'separator-bottom': setting.options.separator === 'bottom', 'separator-top': setting.options.separator === 'top'}")
							small.left-title.text-muted {{setting.title}}
							select.right-control.custom-select.custom-select-sm.auto-width(v-if="setting.control === 'select' && setting.options.values" v-on:input="setSectionData(section, setting.codename, $event.target.value)" v-on:change="Section.saveSectionData(section, setting.codename, $event.target.value)")
								option(v-for="key in Object.keys(setting.options.values)" :selected="section.Data[setting.codename] === key" :value="key") {{setting.options.values[key]}}

							select.right-control.custom-select.custom-select-sm(v-else-if="setting.control === 'asset-select'" v-on:input="setSectionData(section, setting.codename, $event.target.value)" v-on:change="Section.saveSectionData(section, setting.codename, $event.target.value)")
								option(:selected="section.Data[setting.codename] === 'none'" :value="'none'") None
								option(v-for="asset in Asset.AssetsByProject[section.project_id]" :selected="section.Data[setting.codename] === asset.codename" :value="asset.codename") {{asset.codename}}

							select.right-control.custom-select.custom-select-sm(v-else-if="setting.control === 'hls-select'" v-on:input="setSectionData(section, setting.codename, $event.target.value)" v-on:change="Section.saveSectionData(section, setting.codename, $event.target.value)")
								option(:selected="!Object.values(videos).find(vid => `https://v-cdn.prvk.io/${vid.guid}/playlist.m3u8`) === section.Data[setting.codename]" :value="''") Select video to show
								option(v-for="video in videos" :selected="section.Data[setting.codename] === `https://v-cdn.prvk.io/${video.guid}/playlist.m3u8`" :value="`https://v-cdn.prvk.io/${video.guid}/playlist.m3u8`") {{video.title}}

							select.right-control.custom-select.custom-select-sm.auto-width(v-else-if="setting.control === 'type-select' && setting.options.values" v-on:input="setSectionType(section, $event.target.value)" v-on:change="Section.saveSectionType(section, $event.target.value)")
								option(v-for="key in Object.keys(setting.options.values)" :selected="section.type === key" :value="key") {{setting.options.values[key]}}

							label.right-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label(v-else-if="setting.control === 'switch'")
								input.switch-input.form-check-input(type="checkbox" :checked="section.Data.hasOwnProperty(setting.codename) ? section.Data[setting.codename] : setting.value" @change="Section.saveSectionData(section, setting.codename, $event.target.checked)")
								span.switch-slider(data-checked="On" data-unchecked="Off")
								span.switch-handle

							input.right-control.form-control.form-control-sm(v-else-if="setting.control === 'input'" :value="section.Data.hasOwnProperty(setting.codename) ? section.Data[setting.codename] : setting.value" v-on:input="setSectionData(section, setting.codename, $event.target.value)" v-on:change="Section.saveSectionData(section, setting.codename, $event.target.value)")

							textarea.right-control.form-control.form-control-sm(v-else-if="setting.control === 'textarea'" :value="section.Data.hasOwnProperty(setting.codename) ? section.Data[setting.codename] : setting.value" v-on:input="setSectionData(section, setting.codename, $event.target.value)" v-on:change="Section.saveSectionData(section, setting.codename, $event.target.value)")

							.right-part-wrapper.input-with-color(v-else-if="setting.control === 'input-with-color'")
								input.form-control.form-control-sm(type="text" :value="section.Data.hasOwnProperty(setting.codename) ? section.Data[setting.codename] : setting.value" v-on:input="setSectionData(section, setting.codename, $event.target.value)" v-on:change="Section.saveSectionData(section, setting.codename, $event.target.value)" :style="{'width': '60px'}")
								input.form-control.form-control-sm(type="color" :value="section.Data.hasOwnProperty(setting.codename) ? section.Data[setting.codename] : setting.value" v-on:input="setSectionData(section, setting.codename, $event.target.value)" v-on:change="Section.saveSectionData(section, setting.codename, $event.target.value)" :style="{'width': '60px'}")
								span(v-if="setting.options.additionalRightButton" v-on:click="colorInput(section, setting)")
									i.additional-input-button.fa(class='fa-square-o' v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Get color from parent section'}")

							.right-part-wrapper.input-with-range(v-else-if="setting.control === 'input-with-range'")
								input.right-control.form-control.form-control-sm(:value="section.Data.hasOwnProperty(setting.codename) ? section.Data[setting.codename] : setting.value" v-on:input="setSectionData(section, setting.codename, $event.target.value)" v-on:change="Section.saveSectionData(section, setting.codename, $event.target.value)")
								input.range.custom-range.margin-left.no-bg.full-width(type="range" :min="parseFloat(setting.options.range[0])" :max="setting.options.range[1]" :step="setting.options.range[2]" :value="section.Data.hasOwnProperty(setting.codename) ? section.Data[setting.codename] : setting.value" v-on:input="onRangeInput($event.target.value, setting.codename)" v-on:change="onRangeChanged($event.target.value, setting.codename)")

						.condition-wrapper(v-if="checkConditions(section, setting) && section.template_id === setting.template_id && setting.control === 'position-control'")
							.horizontal-part
								.section-x.in-a-row
									small.left-title.text-muted Offset X
									input.form-control.form-control-sm(type="number" step="0.001" :value="section.Data.offsetX || 0" v-on:input="setSectionData(section, 'offsetX', $event.target.value)" v-on:change="Section.saveSectionData(section, 'offsetX', $event.target.value)" :style="{width: '60px'}")
								.section-y.in-a-row
									small.left-title.text-muted Offset Y
									input.form-control.form-control-sm(type="number" step="0.001" :value="section.Data.offsetY || 0" v-on:input="setSectionData(section, 'offsetY', $event.target.value)" v-on:change="Section.saveSectionData(section, 'offsetY', $event.target.value)" :style="{width: '60px'}")
							.horizontal-part
								SettingControlCoordinates(:input="onOffsetInput" :changed="onOffsetChanged" :initialX="section.Data.offsetX || 0" :initialY="section.Data.offsetY || 0" :propertyName="'offset'")
							.horizontal-part
								SettingControlCoordinates(:input="onAnchorInput" :changed="onAnchorChanged" :initialX="section.Data.anchorX ? ((section.Data.anchorX - 0.5) * 2) : 0" :initialY="section.Data.anchorY ? ((section.Data.anchorY - 0.5) * 2) : 0" :propertyName="'anchor'")


					.delete-section-button(v-if="section.Data.newTitle" @click="deleteSection(section.id)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, html: true}")
						.btn.btn-sm.btn-block.btn-outline-danger
							small.left-title Remove section


</template>

<script>

	import Screen 						from './../../mixins/screen'

	import { Project } 					from './../../services/Project'
	import { Section } 					from './../../services/Section'
	import { Asset } 					from './../../services/Asset'
	import { Metadata } 				from './../../services/Metadata'

	import SettingControls 				from './SettingControls'
	import SettingControlCoordinates	from './SettingControlCoordinates'
	import ListGroupControl				from "./CustomControls/ListGroupControl"
	import AssetCompressionData 		from './../Shared/AssetCompressionData'
	import SectionActionsCreate 		from "./SectionActionsCreate";

	import SpawnSectionsList 			from './CustomControls/SpawnSectionsList'


	export default {
		name: "SettingsContentSections",
		mixins: [Screen],
		screen: {
			updateOn: ["Selected Project Changed", "Selected Project Assets Changed", "Selected Project Settings Changed", "Selected Project Sections Changed", "Settings Tab Changed", "Section Removed"],
			events: {
				"Asset Upload Progress": function() {

					this.update();

				},
				"Pseudo Modal Process Hide": function(names) {

					if (!_.find(names, n => n.indexOf('project-section-settings-') === 0) && !_.find(names, n => _.includes(['project-section-control-buttons', 'settings-control-content-width', 'settings-control-offset-top'], n))) this.collapseSection();


				},
				"Section removed": function(sectionId) {

				}
			}
		},
		components: {
			SettingControls,
			SettingControlCoordinates,
			ListGroupControl,
			AssetCompressionData,
			SpawnSectionsList,
			SectionActionsCreate
		},
		data() {

			this.Project = Project;
			this.Section = Section;
			this.Asset = Asset;
			this.Metadata = Metadata;
			this.User = User;

			this._ = window._;

			this.sections = Section.getSelectedProjectSectionsById();
			this.videos = {};
			this.interstitialScreens = [];

			this.playerStyle = null;

			this.templateSettings = {
				1: {
					id: 1,
					template_id: 8,
					codename: 'image-repeat',
					title: 'Image repeat',
					type: 'string',
					value: 'no-repeat',
					control: 'select',
					options: {
						priority: 1,
						condition: {
							sectionCodename: 'background'
						},
						values: {
							'no-repeat': 'No repeat',
							'repeat': 'Repeat',
							'repeat-x': 'Repeat x',
							'repeat-y': 'Repeat y',
							'round': 'Round',
							'space': 'Space'
						}
					}
				},
				2: {
					id: 2,
					template_id: 8,
					codename: 'background-attachment',
					title: 'Background attachment',
					type: 'string',
					value: 'scroll',
					control: 'select',
					options: {
						priority: 1.1,
						condition: {
							sectionCodename: 'background'
						},
						values: {
							'scroll': 'Scroll',
							'fixed': 'Fixed',
							'fixed-along': 'Fixed along with side sections'
						}
					}
				},
				3: {
					id: 3,
					template_id: 8,
					codename: 'visibility',
					title: 'Section visibility',
					type: 'string',
					value: 'visible',
					control: 'select',
					options: {
						priority: 1,
						condition: {
							sectionCodename: ['top', 'left', 'right']
						},
						values: {
							'visible': 'Visible',
							'hidden': 'Hidden'
						}
					}
				},
				4: {
					id: 4,
					template_id: 8,
					codename: 'z-index',
					title: 'Z-index',
					type: 'number',
					value: 2,
					control: 'input',
					options: {
						priority: 1.2,
						condition: {
							sectionCodename: ['top', 'left', 'right']
						},
					}
				},
				5: {
					id: 5,
					template_id: 8,
					codename: 'section-placement',
					title: 'Section placement',
					type: 'string',
					value: 'hybrid-banner',
					control: 'select',
					options: {
						priority: 2,
						separator: 'top',
						condition: {
							sectionCodename: ['top']
						},
						values: {
							'hybrid-banner': 'Hybrid banner',
							'header': 'Header'
						}
					}
				},
				6: {
					id: 6,
					template_id: 8,
					codename: 'clickable-area',
					title: 'Clickable area',
					type: 'string',
					value: 'content-container',
					control: 'select',
					options: {
						priority: 2.1,
						separator: 'top',
						condition: {
							sectionCodename: ['top', 'left', 'right']
						},
						values: {
							'content-container': 'Content container',
							'entire-section': 'Entire section'
						}
					}
				},
				7: {
					id: 7,
					template_id: 8,
					codename: 'top-gap',
					title: 'Top gap',
					type: 'number',
					value: 0,
					control: 'input',
					options: {
						priority: 2.2,
						condition: {
							sectionCodename: ['top'],
							data: {
								'clickable-area': 'entire-section'
							}
						}
					}
				},
				8: {
					id: 8,
					template_id: 8,
					codename: 'bottom-gap',
					title: 'Bottom gap',
					type: 'number',
					value: 0,
					control: 'input',
					options: {
						priority: 2.3,
						condition: {
							sectionCodename: ['top'],
							data: {
								'clickable-area': 'entire-section'
							}
						}
					}
				},
				9: {
					id: 9,
					template_id: 8,
					codename: 'side-gap',
					title: 'Side gap',
					type: 'number',
					value: 0,
					control: 'input',
					options: {
						priority: 2.4,
						condition: {
							sectionCodename: ['top'],
							data: {
								'clickable-area': 'entire-section'
							}
						}
					}
				},
				10: {
					id: 10,
					template_id: 8,
					codename: 'expanded-asset',
					title: 'Expanded asset',
					type: 'string',
					value: 'none',
					control: 'asset-select',
					options: {
						separator: 'top',
						priority: 2.5,
						condition: {
							sectionCodename: 'top'
						}
					}
				},
				11: {
					id: 11,
					template_id: 8,
					codename: 'parentSection',
					title: 'Parent',
					type: 'string',
					value: 'expanded',
					control: 'select',
					options: {
						priority: 0.1,
						values: {
							'expanded': 'Expanded top',
							'collapsed': 'Collapsed top'
						},
						condition: {
							'has-parent': true
						}
					}
				},
				12: {
					id: 12,
					template_id: 8,
					codename: 'type',
					title: 'Section type',
					type: 'string',
					value: 'image',
					control: 'type-select',
					options: {
						priority: 1,
						values: {
							'image': 'Image',
							'html': 'HTML',
							'video': 'YouTube',
							'hls': 'Unbranded video',
							'twitch': 'Twitch',
							'amazon': 'Amazon',
							'spotify': 'Spotify',
							'deezer': 'Deezer',
							'playable': 'Playable'
						},
						condition: {
							'has-parent': true
						}
					}
				},
				13: {
					id: 13,
					template_id: 8,
					codename: 'asset',
					type: 'string',
					title: 'Asset',
					value: '',
					control: 'asset-select',
					options: {
						priority: 2,
						separator: 'top',
						condition: {
							'has-parent': true,
							'type': 'image'
						}
					}
				},
				14: {
					id: 14,
					template_id: 8,
					codename: 'position',
					type: 'number',
					value: 0,
					control: 'position-control',
					options: {
						priority: 3,
						condition: {
							'has-parent': true
						}
					}
				},
				15: {
					id: 15,
					template_id: 8,
					codename: 'expand-on-click',
					title: 'Expand on click',
					type: 'boolean',
					value: false,
					control: 'switch',
					options: {
						separator: 'top',
						priority: 4,
						condition: {
							'has-parent': true,
							data: {
								'parentSection': 'collapsed'
							}
						}
					}
				},
				16: {
					id: 16,
					template_id: 8,
					codename: 'collapse-on-click',
					title: 'Collapse on click',
					type: 'boolean',
					value: false,
					control: 'switch',
					options: {
						separator: 'top',
						priority: 4,
						condition: {
							'has-parent': true,
							data: {
								'parentSection': 'expanded'
							}
						}
					}
				},
				17: {
					id: 17,
					template_id: 8,
					codename: 'video-link',
					title: 'YouTube video id',
					type: 'string',
					value: '',
					control: 'input',
					options: {
						separator: 'top',
						priority: 1.1,
						condition: {
							'has-parent': true,
							type: 'video'
						}
					}
				},
				18: {
					id: 18,
					template_id: 8,
					codename: 'width',
					type: 'number',
					title: 'Width',
					value: 350,
					control: 'input',
					options: {
						priority: 1.5,
						condition: {
							type: ['or', 'video', 'hls', 'twitch', 'amazon', 'spotify', 'deezer', 'html']
						}
					}
				},
				19: {
					id: 19,
					template_id: 8,
					codename: 'height',
					type: 'number',
					title: 'Height',
					value: 250,
					control: 'input',
					options: {
						priority: 1.51,
						condition: {
							type: ['or', 'video', 'hls', 'twitch', 'amazon', 'spotify', 'deezer', 'html']
						}
					}
				},
				// 20: {
				// 	id: 20,
				// 	template_id: 8,
				// 	codename: 'play-on-load',
				// 	type: 'boolean',
				// 	title: 'Play on load',
				// 	value: false,
				// 	control: 'switch',
				// 	options: {
				// 		priority: 1.11,
				// 		condition: {
				// 			type: ['or', 'hls', 'video', 'twitch']
				// 		}
				// 	}
				// },
				21: {
					id: 21,
					template_id: 8,
					codename: 'loop-video',
					type: 'boolean',
					title: 'Loop video',
					value: false,
					control: 'switch',
					options: {
						priority: 1.12,
						condition: {
							type: ['or', 'hls', 'video', 'twitch']
						}
					}
				},
				22: {
					id: 22,
					template_id: 8,
					codename: 'muted',
					type: 'boolean',
					title: 'Muted',
					value: true,
					control: 'switch',
					options: {
						priority: 1.13,
						condition: {
							type: ['or', 'hls', 'video', 'twitch']
						}
					}
				},
				23: {
					id: 23,
					template_id: 8,
					codename: 'hls-video',
					type: 'string',
					title: 'Video',
					value: '',
					control: 'hls-select',
					options: {
						separator: 'top',
						priority: 1.1,
						condition: {
							type: 'hls'
						}
					}
				},
				24: {
					id: 24,
					template_id: 8,
					codename: 'hls-video',
					type: 'string',
					title: 'URL',
					value: '',
					control: 'input',
					options: {
						priority: 1.11,
						condition: {
							type: 'hls'
						}
					}
				},
				25: {
					id: 25,
					template_id: 8,
					codename: 'twitch-type',
					type: 'string',
					title: 'Content type',
					value: 'channel',
					control: 'select',
					options: {
						priority: 1.1,
						separator: 'top',
						values: {
							'channel': 'Channel',
							'video': 'Video',
							'collection': 'Collection'
						},
						condition: {
							type: 'twitch'
						}
					}
				},
				26: {
					id: 26,
					template_id: 8,
					codename: 'twitch-content-id',
					type: 'string',
					title: 'Content id',
					value: '',
					control: 'input',
					options: {
						priority: 1.11,
						condition: {
							type: 'twitch'
						}
					}
				},
				27: {
					id: 27,
					template_id: 8,
					codename: 'amazon-iframe-id',
					type: 'string',
					title: 'IFrame id',
					value: '',
					control: 'input',
					options: {
						separator: 'top',
						priority: 1.1,
						condition: {
							type: 'amazon'
						}
					}
				},
				28: {
					id: 28,
					template_id: 8,
					codename: 'amazon-source',
					type: 'string',
					title: 'Source',
					value: '',
					control: 'input',
					options: {
						priority: 1.11,
						condition: {
							type: 'amazon'
						}
					}
				},
				29: {
					id: 29,
					template_id: 8,
					codename: 'amazon-style',
					type: 'string',
					title: 'Style',
					value: '',
					control: 'input',
					options: {
						priority: 1.12,
						condition: {
							type: 'amazon'
						}
					}
				},
				30: {
					id: 30,
					template_id: 8,
					codename: 'spotify-iframe-id',
					type: 'string',
					title: 'IFrame id',
					value: '',
					control: 'input',
					options: {
						separator: 'top',
						priority: 1.1,
						condition: {
							type: 'spotify'
						}
					}
				},
				31: {
					id: 31,
					template_id: 8,
					codename: 'spotify-source',
					type: 'string',
					title: 'Source',
					value: '',
					control: 'input',
					options: {
						priority: 1.11,
						condition: {
							type: 'spotify'
						}
					}
				},
				32: {
					id: 32,
					template_id: 8,
					codename: 'deezer-url',
					type: 'string',
					title: 'Source',
					value: '',
					control: 'input',
					options: {
						separator: 'top',
						priority: 1.1,
						condition: {
							type: 'deezer'
						}
					}
				},
				33: {
					id: 33,
					template_id: 8,
					codename: 'deezer-theme',
					type: 'string',
					title: 'Theme',
					value: '',
					control: 'select',
					options: {
						priority: 1.11,
						values: {
							'dark': 'Dark',
							'light': 'Light',
							'auto': 'Auto'
						},
						condition: {
							type: 'deezer'
						}
					}
				},
				34: {
					id: 34,
					template_id: 8,
					codename: 'deezer-tracklist',
					type: 'boolean',
					title: 'Show tracklist',
					value: false,
					control: 'switch',
					options: {
						priority: 1.12,
						condition: {
							type: 'deezer'
						}
					}
				},
				// 35: {
				// 	id: 35,
				// 	template_id: 8,
				// 	codename: 'type',
				// 	title: 'Section type',
				// 	type: 'string',
				// 	value: 'image',
				// 	control: 'type-select',
				// 	options: {
				// 		priority: 1,
				// 		values: {
				// 			'image': 'Image',
				// 			//'html': 'HTML',
				// 			// 'video': 'YouTube',
				// 			// 'hls': 'Unbranded video',
				// 			// 'twitch': 'Twitch',
				// 			// 'amazon': 'Amazon',
				// 			// 'spotify': 'Spotify',
				// 			// 'deezer': 'Deezer'
				// 		},
				// 		condition: {
				// 			sectionCodename: 'left'
				// 		}
				// 	}
				// },
				36: {
					id: 36,
					template_id: 8,
					codename: 'top-gap',
					title: 'Top gap',
					type: 'number',
					value: 0,
					control: 'input',
					options: {
						priority: 2.2,
						condition: {
							sectionCodename: ['left', 'right'],
							data: {
								'clickable-area': 'entire-section'
							}
						}
					}
				},
				37: {
					id: 37,
					template_id: 8,
					codename: 'side-gap',
					title: 'Side gap',
					type: 'number',
					value: 0,
					control: 'input',
					options: {
						priority: 2.21,
						condition: {
							sectionCodename: ['left', 'right'],
							data: {
								'clickable-area': 'entire-section'
							}
						}
					}
				},
				38: {
					id: 38,
					template_id: 8,
					codename: 'content-gap',
					title: 'Content gap',
					type: 'number',
					value: 10,
					control: 'input',
					options: {
						priority: 2.22,
						condition: {
							sectionCodename: ['left', 'right'],
							data: {
								'clickable-area': 'entire-section'
							}
						}
					}
				},
				39: {
					id: 39,
					template_id: 8,
					codename: 'placement-style',
					title: 'Placement style',
					type: 'string',
					value: 'lock-to-content',
					control: 'select',
					options: {
						priority: 2.3,
						condition: {
							sectionCodename: ['left', 'right']
						},
						values: {
							'lock-to-content': 'Lock to content',
							'center': 'Center'
						}
					}
				},
				40: {
					id: 40,
					template_id: 8,
					codename: 'min-scale',
					title: 'Minimal scale(%)',
					type: 'string',
					value: '50',
					control: 'input',
					options: {
						priority: 2.31,
						condition: {
							sectionCodename: ['left', 'right']
						}
					}
				},
				41: {
					id: 41,
					template_id: 8,
					codename: 'sticky',
					title: 'Sticky',
					type: 'boolean',
					value: false,
					control: 'switch',
					options: {
						priority: 2.32,
						condition: {
							sectionCodename: ['left', 'right']
						}
					}
				},
				42: {
					id: 42,
					template_id: 8,
					codename: 'stickiness-top',
					title: 'Stickiness top',
					type: 'number',
					value: 250,
					control: 'input',
					options: {
						priority: 2.33,
						condition: {
							sectionCodename: ['left', 'right'],
							data: {
								'sticky': true
							}
						}
					}
				},
				43: {
					id: 43,
					template_id: 8,
					codename: 'offsetY',
					title: 'Offset Y',
					type: 'number',
					value: 0,
					control: 'input-with-range',
					options: {
						priority: 2.299,
						condition: {
							sectionCodename: ['left', 'right']
						},
						range: [-150, 150, 0.5],
						separator: 'top'
					}
				},
				44: {
					id: 44,
					template_id: 8,
					codename: 'responsive-to-zoom',
					title: 'Responsive to zoom',
					type: 'boolean',
					value: false,
					control: 'switch',
					options: {
						priority: 2.301,
						condition: {
							sectionCodename: ['left', 'right']
						}
					}
				},
				45: {
					id: 45,
					template_id: 8,
					codename: 'position',
					type: 'number',
					value: 0,
					control: 'position-control',
					options: {
						priority: 2.52,
						condition: {
							sectionCodename: 'top'
						},
						separator: 'top'
					}
				},
				46: {
					id: 46,
					template_id: 8,
					codename: 'width',
					title: 'Width',
					type: 'number',
					//value: 0,
					control: 'input-with-range',
					options: {
						priority: 2.51,
						condition: {
							sectionCodename: 'top'
						},
						range: [0, 1500, 1],
						separator: 'top'
					}
				},
				47: {
					id: 47,
					template_id: 8,
					codename: 'height',
					title: 'Height',
					type: 'number',
					//value: 0,
					control: 'input-with-range',
					options: {
						priority: 2.511,
						condition: {
							sectionCodename: 'top'
						},
						range: [0, 1500, 1],
						//separator: 'top'
					}
				},
				48: {
					id: 48,
					template_id: 8,
					codename: 'width',
					title: 'Width',
					type: 'number',
					//value: 0,
					control: 'input-with-range',
					options: {
						priority: 2.28,
						condition: {
							sectionCodename: ['left', 'right']
						},
						range: [0, 1500, 1],
						separator: 'top'
					}
				},
				49: {
					id: 49,
					template_id: 8,
					codename: 'height',
					title: 'Height',
					type: 'number',
					//value: 0,
					control: 'input-with-range',
					options: {
						priority: 2.281,
						condition: {
							sectionCodename: ['left', 'right']
						},
						range: [0, 1500, 1],
						//separator: 'top'
					}
				},
				50: {
					id: 50,
					template_id: 8,
					codename: 'visual-effect',
					title: 'Visual effect',
					type: 'string',
					value: 'none',
					control: 'select',
					options: {
						priority: 6,
						condition: {
							sectionCodename: ['top', 'left', 'right']
						},
						values: {
							'none': 'None',
							'glow': 'Glow',
							'jump': 'Jump',
							'blink': 'Blink',
							'wiggle': 'Wiggle',
							'custom': 'Custom'
						},
						separator: 'top'
					}
				},
				51: {
					id: 51,
					template_id: 8,
					codename: 'visual-effect-on-hover',
					type: 'boolean',
					title: 'Apply on hover',
					value: false,
					control: 'switch',
					options: {
						priority: 6.01,
						condition: {
							sectionCodename: ['top', 'left', 'right']
						}
					}
				},
				52: {
					id: 52,
					template_id: 8,
					codename: 'change-on-scroll',
					title: 'Change on scroll',
					type: 'string',
					value: 'none',
					control: 'asset-select',
					options: {
						separator: 'top',
						priority: 5.5,
						condition: {
							sectionCodename: ['left', 'right']
						}
					}
				},
				53: {
					id: 53,
					template_id: 10,
					codename: 'image-repeat',
					title: 'Image repeat',
					type: 'string',
					value: 'no-repeat',
					control: 'select',
					options: {
						priority: 1,
						condition: {
							sectionCodename: 'background'
						},
						values: {
							'no-repeat': 'No repeat',
							'repeat': 'Repeat',
							'repeat-x': 'Repeat x',
							'repeat-y': 'Repeat y',
							'round': 'Round',
							'space': 'Space'
						}
					}
				},
				54: {
					id: 54,
					template_id: 10,
					codename: 'background-attachment',
					title: 'Background attachment',
					type: 'string',
					value: 'scroll',
					control: 'select',
					options: {
						priority: 1.1,
						condition: {
							sectionCodename: 'background'
						},
						values: {
							'scroll': 'Scroll',
							'fixed': 'Fixed',
							'fixed-along': 'Fixed along with side sections'
						}
					}
				},
				55: {
					id: 55,
					template_id: 10,
					codename: 'visibility',
					title: 'Section visibility',
					type: 'string',
					value: 'visible',
					control: 'select',
					options: {
						priority: 1,
						condition: {
							sectionCodename: ['top', 'left', 'right']
						},
						values: {
							'visible': 'Visible',
							'hidden': 'Hidden'
						}
					}
				},
				56: {
					id: 56,
					template_id: 10,
					codename: 'z-index',
					title: 'Z-index',
					type: 'number',
					value: 2,
					control: 'input',
					options: {
						priority: 1.2,
						condition: {
							sectionCodename: ['top', 'left', 'right']
						},
					}
				},
				57: {
					id: 57,
					template_id: 10,
					codename: 'clickable-area',
					title: 'Clickable area',
					type: 'string',
					value: 'content-container',
					control: 'select',
					options: {
						priority: 2.1,
						separator: 'top',
						condition: {
							sectionCodename: ['top', 'left', 'right']
						},
						values: {
							'content-container': 'Content container',
							'entire-section': 'Entire section'
						}
					}
				},
				58: {
					id: 58,
					template_id: 10,
					codename: 'top-gap',
					title: 'Top gap',
					type: 'number',
					value: 0,
					control: 'input',
					options: {
						priority: 2.2,
						condition: {
							sectionCodename: ['top'],
							data: {
								'clickable-area': 'entire-section'
							}
						}
					}
				},
				59: {
					id: 59,
					template_id: 10,
					codename: 'bottom-gap',
					title: 'Bottom gap',
					type: 'number',
					value: 0,
					control: 'input',
					options: {
						priority: 2.3,
						condition: {
							sectionCodename: ['top'],
							data: {
								'clickable-area': 'entire-section'
							}
						}
					}
				},
				60: {
					id: 60,
					template_id: 10,
					codename: 'side-gap',
					title: 'Side gap',
					type: 'number',
					value: 0,
					control: 'input',
					options: {
						priority: 2.4,
						condition: {
							sectionCodename: ['top'],
							data: {
								'clickable-area': 'entire-section'
							}
						}
					}
				},
				61: {
					id: 61,
					template_id: 10,
					codename: 'width',
					title: 'Width',
					type: 'number',
					//value: 0,
					control: 'input-with-range',
					options: {
						priority: 2.51,
						condition: {
							sectionCodename: 'top'
						},
						range: [0, 1500, 1],
						separator: 'top'
					}
				},
				62: {
					id: 62,
					template_id: 10,
					codename: 'height',
					title: 'Height',
					type: 'number',
					//value: 0,
					control: 'input-with-range',
					options: {
						priority: 2.511,
						condition: {
							sectionCodename: 'top'
						},
						range: [0, 1500, 1],
						//separator: 'top'
					}
				},
				63: {
					id: 63,
					template_id: 10,
					codename: 'position',
					type: 'number',
					value: 0,
					control: 'position-control',
					options: {
						priority: 2.52,
						condition: {
							sectionCodename: 'top'
						},
						separator: 'top'
					}
				},
				64: {
					id: 64,
					template_id: 10,
					codename: 'visual-effect',
					title: 'Visual effect',
					type: 'string',
					value: 'none',
					control: 'select',
					options: {
						priority: 6,
						condition: {
							sectionCodename: ['top', 'left', 'right']
						},
						values: {
							'none': 'None',
							'glow': 'Glow',
							'jump': 'Jump',
							'blink': 'Blink',
							'wiggle': 'Wiggle',
							'custom': 'Custom'
						},
						separator: 'top'
					}
				},
				65: {
					id: 65,
					template_id: 10,
					codename: 'visual-effect-on-hover',
					type: 'boolean',
					title: 'Apply on hover',
					value: false,
					control: 'switch',
					options: {
						priority: 6.01,
						condition: {
							sectionCodename: ['top', 'left', 'right']
						}
					}
				},
				66: {
					id: 66,
					template_id: 10,
					codename: 'width',
					title: 'Width',
					type: 'number',
					//value: 0,
					control: 'input-with-range',
					options: {
						priority: 2.28,
						condition: {
							sectionCodename: ['left', 'right']
						},
						range: [0, 1500, 1],
						separator: 'top'
					}
				},
				67: {
					id: 67,
					template_id: 10,
					codename: 'height',
					title: 'Height',
					type: 'number',
					//value: 0,
					control: 'input-with-range',
					options: {
						priority: 2.281,
						condition: {
							sectionCodename: ['left', 'right']
						},
						range: [0, 1500, 1],
						//separator: 'top'
					}
				},
				68: {
					id: 68,
					template_id: 10,
					codename: 'offsetY',
					title: 'Offset Y',
					type: 'number',
					value: 0,
					control: 'input-with-range',
					options: {
						priority: 2.299,
						condition: {
							sectionCodename: ['left', 'right']
						},
						range: [-150, 150, 0.5],
						separator: 'top'
					}
				},
				69: {
					id: 69,
					template_id: 10,
					codename: 'placement-style',
					title: 'Placement style',
					type: 'string',
					value: 'lock-to-content',
					control: 'select',
					options: {
						priority: 2.3,
						condition: {
							sectionCodename: ['left', 'right']
						},
						values: {
							'lock-to-content': 'Lock to content',
							'center': 'Center'
						}
					}
				},
				70: {
					id: 70,
					template_id: 10,
					codename: 'responsive-to-zoom',
					title: 'Responsive to zoom',
					type: 'boolean',
					value: false,
					control: 'switch',
					options: {
						priority: 2.301,
						condition: {
							sectionCodename: ['left', 'right']
						}
					}
				},
				71: {
					id: 71,
					template_id: 10,
					codename: 'min-scale',
					title: 'Minimal scale(%)',
					type: 'string',
					value: '50',
					control: 'input',
					options: {
						priority: 2.31,
						condition: {
							sectionCodename: ['left', 'right']
						}
					}
				},
				72: {
					id: 72,
					template_id: 10,
					codename: 'sticky',
					title: 'Sticky',
					type: 'boolean',
					value: false,
					control: 'switch',
					options: {
						priority: 2.32,
						condition: {
							sectionCodename: ['left', 'right']
						}
					}
				},
				73: {
					id: 73,
					template_id: 10,
					codename: 'stickiness-top',
					title: 'Stickiness top',
					type: 'number',
					value: 250,
					control: 'input',
					options: {
						priority: 2.33,
						condition: {
							sectionCodename: ['left', 'right'],
							data: {
								'sticky': true
							}
						}
					}
				},
				74: {
					id: 74,
					template_id: 10,
					codename: 'change-on-scroll',
					title: 'Change on scroll',
					type: 'string',
					value: 'none',
					control: 'asset-select',
					options: {
						separator: 'top',
						priority: 5.5,
						condition: {
							sectionCodename: ['left', 'right']
						}
					}
				},
				75: {
					id: 75,
					template_id: 10,
					codename: 'carousel-interval',
					title: 'Carousel interval (ms)',
					type: 'number',
					value: 7500,
					control: 'input',
					options: {
						priority: 8,
						condition: {
							sectionCodename: ['left', 'right']
						},
						separator: 'top'
					}
				},
				77: {
					id: 77,
					template_id: 10,
					codename: 'parentSection',
					title: 'Parent',
					type: 'string',
					value: 'expanded',
					control: 'select',
					options: {
						priority: 0.1,
						values: {
							'top': 'Top section',
							'left': 'Left section',
							'right': 'Right section'
						},
						condition: {
							'has-parent': true
						}
					}
				},
				78: {
					id: 78,
					template_id: 10,
					codename: 'type',
					title: 'Section type',
					type: 'string',
					value: 'image',
					control: 'type-select',
					options: {
						priority: 1,
						values: {
							'image': 'Image',
							//'html': 'HTML',
							'video': 'YouTube',
							'hls': 'Unbranded video',
							'twitch': 'Twitch',
							'amazon': 'Amazon',
							'spotify': 'Spotify',
							'deezer': 'Deezer',
							'text': 'Text'
						},
						condition: {
							'has-parent': true
						}
					}
				},
				79: {
					id: 79,
					template_id: 10,
					codename: 'asset',
					type: 'string',
					title: 'Asset',
					value: '',
					control: 'asset-select',
					options: {
						priority: 2,
						separator: 'top',
						condition: {
							'has-parent': true,
							'type': 'image'
						}
					}
				},
				// 80: {
				// 	id: 80,
				// 	template_id: 10,
				// 	codename: 'position',
				// 	type: 'number',
				// 	value: 0,
				// 	control: 'position-control',
				// 	options: {
				// 		priority: 3,
				// 		condition: {
				// 			'has-parent': true
				// 		}
				// 	}
				// },
				81: {
					id: 81,
					template_id: 10,
					codename: 'video-link',
					title: 'YouTube video id',
					type: 'string',
					value: '',
					control: 'input',
					options: {
						separator: 'top',
						priority: 1.1,
						condition: {
							'has-parent': true,
							type: 'video'
						}
					}
				},
				82: {
					id: 82,
					template_id: 10,
					codename: 'width',
					type: 'number',
					title: 'Width',
					value: 445,
					control: 'input',
					options: {
						priority: 1.5,
						condition: {
							'has-parent': true,
							type: ['or', 'image', 'video', 'hls', 'twitch', 'amazon', 'spotify', 'deezer']
						}
					}
				},
				83: {
					id: 83,
					template_id: 10,
					codename: 'height',
					type: 'number',
					title: 'Height',
					value: 250,
					control: 'input',
					options: {
						priority: 1.51,
						condition: {
							'has-parent': true,
							type: ['or', 'image', 'video', 'hls', 'twitch', 'amazon', 'spotify', 'deezer']
						}
					}
				},
				// 20: {
				// 	id: 20,
				// 	template_id: 8,
				// 	codename: 'play-on-load',
				// 	type: 'boolean',
				// 	title: 'Play on load',
				// 	value: false,
				// 	control: 'switch',
				// 	options: {
				// 		priority: 1.11,
				// 		condition: {
				// 			type: ['or', 'hls', 'video', 'twitch']
				// 		}
				// 	}
				// },
				84: {
					id: 84,
					template_id: 10,
					codename: 'loop-video',
					type: 'boolean',
					title: 'Loop video',
					value: true,
					control: 'switch',
					options: {
						priority: 1.12,
						condition: {
							type: ['or', 'hls', 'video', 'twitch']
						}
					}
				},
				85: {
					id: 85,
					template_id: 10,
					codename: 'muted',
					type: 'boolean',
					title: 'Muted',
					value: true,
					control: 'switch',
					options: {
						priority: 1.13,
						condition: {
							type: ['or', 'hls', 'video', 'twitch']
						}
					}
				},
				86: {
					id: 86,
					template_id: 10,
					codename: 'hls-video',
					type: 'string',
					title: 'Video',
					value: '',
					control: 'hls-select',
					options: {
						separator: 'top',
						priority: 1.1,
						condition: {
							type: 'hls'
						}
					}
				},
				87: {
					id: 87,
					template_id: 10,
					codename: 'hls-video',
					type: 'string',
					title: 'URL',
					value: '',
					control: 'input',
					options: {
						priority: 1.11,
						condition: {
							type: 'hls'
						}
					}
				},
				88: {
					id: 88,
					template_id: 10,
					codename: 'twitch-type',
					type: 'string',
					title: 'Content type',
					value: 'channel',
					control: 'select',
					options: {
						priority: 1.1,
						separator: 'top',
						values: {
							'channel': 'Channel',
							'video': 'Video',
							'collection': 'Collection'
						},
						condition: {
							type: 'twitch'
						}
					}
				},
				89: {
					id: 89,
					template_id: 10,
					codename: 'twitch-content-id',
					type: 'string',
					title: 'Content id',
					value: '',
					control: 'input',
					options: {
						priority: 1.11,
						condition: {
							type: 'twitch'
						}
					}
				},
				90: {
					id: 90,
					template_id: 10,
					codename: 'amazon-iframe-id',
					type: 'string',
					title: 'IFrame id',
					value: '',
					control: 'input',
					options: {
						separator: 'top',
						priority: 1.1,
						condition: {
							type: 'amazon'
						}
					}
				},
				91: {
					id: 91,
					template_id: 10,
					codename: 'amazon-source',
					type: 'string',
					title: 'Source',
					value: '',
					control: 'input',
					options: {
						priority: 1.11,
						condition: {
							type: 'amazon'
						}
					}
				},
				92: {
					id: 92,
					template_id: 10,
					codename: 'amazon-style',
					type: 'string',
					title: 'Style',
					value: '',
					control: 'input',
					options: {
						priority: 1.12,
						condition: {
							type: 'amazon'
						}
					}
				},
				93: {
					id: 93,
					template_id: 10,
					codename: 'spotify-iframe-id',
					type: 'string',
					title: 'IFrame id',
					value: '',
					control: 'input',
					options: {
						separator: 'top',
						priority: 1.1,
						condition: {
							type: 'spotify'
						}
					}
				},
				94: {
					id: 94,
					template_id: 10,
					codename: 'spotify-source',
					type: 'string',
					title: 'Source',
					value: '',
					control: 'input',
					options: {
						priority: 1.11,
						condition: {
							type: 'spotify'
						}
					}
				},
				95: {
					id: 95,
					template_id: 10,
					codename: 'deezer-url',
					type: 'string',
					title: 'Source',
					value: '',
					control: 'input',
					options: {
						separator: 'top',
						priority: 1.1,
						condition: {
							type: 'deezer'
						}
					}
				},
				96: {
					id: 96,
					template_id: 10,
					codename: 'deezer-theme',
					type: 'string',
					title: 'Theme',
					value: '',
					control: 'select',
					options: {
						priority: 1.11,
						values: {
							'dark': 'Dark',
							'light': 'Light',
							'auto': 'Auto'
						},
						condition: {
							type: 'deezer'
						}
					}
				},
				97: {
					id: 97,
					template_id: 10,
					codename: 'deezer-tracklist',
					type: 'boolean',
					title: 'Show tracklist',
					value: false,
					control: 'switch',
					options: {
						priority: 1.12,
						condition: {
							type: 'deezer'
						}
					}
				},
				98: {
					id: 98,
					template_id: 10,
					codename: 'top-gap',
					title: 'Top gap',
					type: 'number',
					value: 0,
					control: 'input',
					options: {
						priority: 2.2,
						condition: {
							sectionCodename: ['left', 'right'],
							data: {
								'clickable-area': 'entire-section'
							}
						}
					}
				},
				99: {
					id: 99,
					template_id: 10,
					codename: 'side-gap',
					title: 'Side gap',
					type: 'number',
					value: 0,
					control: 'input',
					options: {
						priority: 2.21,
						condition: {
							sectionCodename: ['left', 'right'],
							data: {
								'clickable-area': 'entire-section'
							}
						}
					}
				},
				100: {
					id: 100,
					template_id: 10,
					codename: 'content-gap',
					title: 'Content gap',
					type: 'number',
					value: 10,
					control: 'input',
					options: {
						priority: 2.22,
						condition: {
							sectionCodename: ['left', 'right'],
							data: {
								'clickable-area': 'entire-section'
							}
						}
					}
				},
				101: {
					id: 101,
					template_id: 10,
					codename: 'carousel-offset-y',
					title: 'Carousel offset Y',
					type: 'number',
					value: 50,
					control: 'input-with-range',
					options: {
						priority: 8.5,
						condition: {
							sectionCodename: ['left', 'right']
						},
						range: [0, 100, 0.5],
						separator: 'top'
					}
				},
				102: {
					id: 102,
					template_id: 10,
					codename: 'override-image-url',
					type: 'string',
					title: 'Override json key',
					value: '',
					control: 'input',
					options: {
						priority: 1.3,
						//separator: 'top',
						condition: {
							'sectionCodename': ['not', 'background'],
							'type': 'image',
							'setting': {
								'use-dynamic-values': true
							}
						}
					}
				},
				103: {
					id: 103,
					template_id: 10,
					codename: 'override-video-url',
					type: 'string',
					title: 'Override json key',
					value: '',
					control: 'input',
					options: {
						priority: 1.09,
						//separator: 'top',
						condition: {
							'sectionCodename': ['not', 'background'],
							'type': 'hls',
							'setting': {
								'use-dynamic-values': true
							}
						}
					}
				},
				104: {
					id: 104,
					template_id: 10,
					codename: 'carousel-as-background',
					title: 'Use carousel assets as background',
					type: 'boolean',
					value: false,
					control: 'switch',
					options: {
						priority: 7,
						condition: {
							sectionCodename: ['top', 'left', 'right']
						},
						separator: 'top'
					}
				},
				105: {
					id: 105,
					template_id: 10,
					codename: 'carousel-fullscreen-filter',
					title: 'Carousel fullscreen filter',
					type: 'input',
					value: 'blur(15px) grayscale(50%)',
					control: 'input',
					options: {
						priority: 7.1,
						condition: {
							sectionCodename: ['top', 'left', 'right']
						}
					}
				},
				106: {
					id: 106,
					template_id: 9,
					codename: 'type',
					title: 'Section type',
					type: 'string',
					value: 'image',
					control: 'type-select',
					options: {
						priority: 1,
						values: {
							'image': 'Image',
							'hls': 'Unbranded video',
							'twitch': 'Twitch',
							// 'amazon': 'Amazon',
							// 'spotify': 'Spotify',
							// 'deezer': 'Deezer'
						},
						condition: {
							'sectionCodename': ['not', 'background', 'overlay']
						}
					},
				},
				107: {
					id: 107,
					template_id: 9,
					codename: 'asset',
					title: 'Asset',
					type: 'string',
					value: 'none',
					control: 'asset-select',
					options: {
						separator: 'top',
						priority: 2,
						condition: {
							type: 'image',
							'sectionCodename': ['not', 'background', 'overlay']
						}
					}
				},
				108: {
					id: 108,
					template_id: 9,
					codename: 'hls-video',
					type: 'string',
					title: 'Video',
					value: '',
					control: 'hls-select',
					options: {
						separator: 'top',
						priority: 2.1,
						condition: {
							type: 'hls',
							'sectionCodename': ['not', 'background', 'overlay']
						}
					}
				},
				109: {
					id: 109,
					template_id: 9,
					codename: 'hls-video',
					type: 'string',
					title: 'URL',
					value: '',
					control: 'input',
					options: {
						priority: 2.2,
						condition: {
							type: 'hls',
							'sectionCodename': ['not', 'background', 'overlay']
						}
					}
				},
				110: {
					id: 100,
					template_id: 9,
					codename: 'autoplay-video',
					type: 'boolean',
					title: 'Autoplay',
					value: true,
					control: 'switch',
					options: {
						priority: 2.3,
						condition: {
							type: ['or', 'hls', 'video', 'twitch'],
							'sectionCodename': ['not', 'background', 'overlay']
						}
					}
				},
				111: {
					id: 111,
					template_id: 9,
					codename: 'loop-video',
					type: 'boolean',
					title: 'Loop video',
					value: true,
					control: 'switch',
					options: {
						priority: 2.4,
						condition: {
							type: ['or', 'hls', 'video', 'twitch'],
							'sectionCodename': ['not', 'background', 'overlay']
						}
					}
				},
				112: {
					id: 112,
					template_id: 9,
					codename: 'muted',
					type: 'boolean',
					title: 'Muted',
					value: true,
					control: 'switch',
					options: {
						priority: 2.5,
						condition: {
							type: ['or', 'hls', 'video', 'twitch'],
							'sectionCodename': ['not', 'background', 'overlay']
						}
					}
				},
				113: {
					id: 113,
					template_id: 9,
					codename: 'width',
					title: 'Width',
					type: 'number',
					value: 300,
					control: 'input-with-range',
					options: {
						priority: 2.6,
						condition: {
							type: ['or', 'image', 'hls', 'video', 'twitch'],
							'sectionCodename': ['not', 'background', 'overlay']
						},
						range: [0, 1000, 0.5],
						separator: 'top'
					}
				},
				114: {
					id: 114,
					template_id: 9,
					codename: 'height',
					title: 'Height',
					type: 'number',
					value: 250,
					control: 'input-with-range',
					options: {
						priority: 2.7,
						condition: {
							type: ['or', 'image', 'hls', 'video', 'twitch'],
							'sectionCodename': ['not', 'background', 'overlay']
						},
						range: [0, 1000, 0.5]
					}
				},
				115: {
					id: 115,
					template_id: 9,
					codename: 'position',
					type: 'number',
					value: 0,
					control: 'position-control',
					options: {
						priority: 3,
						condition: {
							type: ['or', 'image', 'hls', 'video', 'twitch'],
							'sectionCodename': ['not', 'background', 'overlay']
						}
					}
				},
				116: {
					id: 116,
					template_id: 9,
					codename: 'override-json-key',
					title: 'Override JSON key',
					type: 'string',
					value: '',
					control: 'input',
					options: {
						priority: 1.01,
						separator: 'top',
						condition: {
							type: ['or', 'image', 'hls', 'video'],
							'sectionCodename': ['not', 'background', 'overlay']
						}
					}
				},
				117: {
					id: 117,
					template_id: 9,
					codename: 'enable-parallax',
					title: 'Enable parallax',
					type: 'boolean',
					value: true,
					control: 'switch',
					options: {
						priority: 1,
						condition: {
							'sectionCodename': 'background'
						}
					}
				},
				118: {
					id: 118,
					template_id: 9,
					codename: 'override-size',
					title: 'Override size',
					type: 'boolean',
					value: false,
					control: 'switch',
					options: {
						priority: 3,
						condition: {
							'type': 'image',
							data: {
								'originalSectionCodename': undefined
							}
						},
						separator: 'top'
					}
				},
				119: {
					id: 119,
					template_id: 9,
					codename: 'width',
					title: 'Width',
					type: 'number',
					value: 300,
					control: 'input-with-range',
					options: {
						priority: 3.1,
						condition: {
							type: 'image',
							data: {
								'override-size': true
							}
						},
						range: [0, 1500, 1],
						separator: 'top'
					}
				},
				120: {
					id: 120,
					template_id: 9,
					codename: 'height',
					title: 'Height',
					type: 'number',
					value: 250,
					control: 'input-with-range',
					options: {
						priority: 3.2,
						condition: {
							type: 'image',
							data: {
								'override-size': true
							}
						},
						range: [0, 1500, 1]
					}
				},
				121: {
					id: 121,
					template_id: 9,
					codename: 'override-json-key',
					title: 'Override JSON key',
					type: 'string',
					value: '',
					control: 'input',
					options: {
						priority: 0.1,
						condition: {
							//type: ['or', 'image', 'hls', 'video', 'twitch'],
							'sectionCodename': ['or', 'background', 'overlay']
						}
					}
				},
				122: {
					id: 122,
					template_id: 10,
					codename: 'use-as-carousel-item',
					title: 'Use as carousel item',
					type: 'boolean',
					value: true,
					control: 'switch',
					options: {
						priority: 0.11,
						condition: {
							'has-parent': true
						}
					}
				},
				123: {
					id: 123,
					template_id: 10,
					codename: 'position',
					type: 'number',
					value: 0,
					control: 'position-control',
					options: {
						priority: 1.53,
						condition: {
							'has-parent': true,
							data: {
								'use-as-carousel-item': false
							}
						}
					}
				},
				124: {
					id: 124,
					template_id: 10,
					codename: 'override-text-url',
					type: 'string',
					title: 'Override json key',
					value: '',
					control: 'input',
					options: {
						priority: 1.3,
						//separator: 'top',
						condition: {
							'sectionCodename': ['not', 'background'],
							'type': 'text',
							'setting': {
								'use-dynamic-values': true
							}
						}
					}
				},
				125: {
					id: 125,
					template_id: 10,
					codename: 'text',
					type: 'string',
					title: 'Text',
					value: 'Sample Text',
					control: 'textarea',
					options: {
						priority: 1.4,
						//separator: 'top',
						condition: {
							'sectionCodename': ['not', 'background'],
							'type': 'text',
						}
					}
				},
				126: {
					id: 126,
					template_id: 10,
					codename: 'text-color',
					type: 'string',
					title: 'Text color',
					value: '#ffffff',
					control: 'input-with-color',
					options: {
						priority: 1.5,
						//separator: 'top',
						condition: {
							'sectionCodename': ['not', 'background'],
							'type': 'text',
						}
					}
				},
				127: {
					id: 127,
					template_id: 10,
					codename: 'font-size',
					type: 'number',
					title: 'Font size (px)',
					value: '32',
					control: 'input',
					options: {
						priority: 1.401,
						//separator: 'top',
						condition: {
							'sectionCodename': ['not', 'background'],
							'type': 'text'
						}
					}
				},
				128: {
					id: 128,
					template_id: 11,
					codename: 'section-placement',
					title: 'Section placement',
					type: 'string',
					value: 'bottom',
					control: 'select',
					options: {
						priority: 0,
						//separator: 'top',
						condition: {
							sectionCodename: ['floor-collapsed', 'floor-expanded']
						},
						values: {
							'top': 'Top',
							'bottom': 'Bottom'
						}
					}
				},
				129: {
					id: 129,
					template_id: 11,
					codename: 'parentSection',
					title: 'Parent',
					type: 'string',
					value: 'expanded',
					control: 'select',
					options: {
						priority: 0.1,
						values: {
							'expanded': 'Floor section expanded',
							'collapsed': 'Floor section collapsed'
						},
						condition: {
							'has-parent': true
						},
						separator: 'top'
					}
				},
				130: {
					id: 130,
					template_id: 11,
					codename: 'type',
					title: 'Section type',
					type: 'string',
					value: 'image',
					control: 'type-select',
					options: {
						priority: 1,
						values: {
							'image': 'Image',
							//'html': 'HTML',
							'video': 'YouTube',
							'hls': 'Unbranded video',
							'twitch': 'Twitch',
							'amazon': 'Amazon',
							'spotify': 'Spotify',
							'deezer': 'Deezer',
							'color': 'Color'
						},
						condition: {
							'has-parent': true
						}
					}
				},
				131: {
					id: 131,
					template_id: 11,
					codename: 'position',
					type: 'number',
					value: 0,
					control: 'position-control',
					options: {
						priority: 3,
						condition: {
							'has-parent': true,
							type: ['or', 'image', 'video', 'hls', 'twitch', 'amazon', 'spotify', 'deezer']
						},
						separator: 'top'
					}
				},
				132: {
					id: 132,
					template_id: 11,
					codename: 'asset',
					type: 'string',
					title: 'Asset',
					value: '',
					control: 'asset-select',
					options: {
						priority: 2,
						separator: 'top',
						condition: {
							'has-parent': true,
							'type': 'image'
						}
					}
				},
				133: {
					id: 133,
					template_id: 11,
					codename: 'width',
					type: 'number',
					title: 'Width',
					value: 350,
					control: 'input',
					options: {
						priority: 1.5,
						condition: {
							type: ['or', 'video', 'hls', 'twitch', 'amazon', 'spotify', 'deezer']
						}
					}
				},
				134: {
					id: 134,
					template_id: 11,
					codename: 'height',
					type: 'number',
					title: 'Height',
					value: 250,
					control: 'input',
					options: {
						priority: 1.51,
						condition: {
							type: ['or', 'video', 'hls', 'twitch', 'amazon', 'spotify', 'deezer']
						}
					}
				},
				135: {
					id: 135,
					template_id: 11,
					codename: 'loop-video',
					type: 'boolean',
					title: 'Loop video',
					value: true,
					control: 'switch',
					options: {
						priority: 1.12,
						condition: {
							type: ['or', 'hls', 'video', 'twitch']
						}
					}
				},
				136: {
					id: 136,
					template_id: 11,
					codename: 'muted',
					type: 'boolean',
					title: 'Muted',
					value: true,
					control: 'switch',
					options: {
						priority: 1.13,
						condition: {
							type: ['or', 'hls', 'video', 'twitch']
						}
					}
				},
				137: {
					id: 137,
					template_id: 11,
					codename: 'video-link',
					title: 'YouTube video id',
					type: 'string',
					value: '',
					control: 'input',
					options: {
						separator: 'top',
						priority: 1.1,
						condition: {
							'has-parent': true,
							type: 'video'
						}
					}
				},
				138: {
					id: 138,
					template_id: 11,
					codename: 'hls-video',
					type: 'string',
					title: 'Video',
					value: '',
					control: 'hls-select',
					options: {
						separator: 'top',
						priority: 1.1,
						condition: {
							type: 'hls'
						}
					}
				},
				139: {
					id: 139,
					template_id: 11,
					codename: 'hls-video',
					type: 'string',
					title: 'URL',
					value: '',
					control: 'input',
					options: {
						priority: 1.11,
						condition: {
							type: 'hls'
						}
					}
				},
				140: {
					id: 140,
					template_id: 11,
					codename: 'twitch-type',
					type: 'string',
					title: 'Content type',
					value: 'channel',
					control: 'select',
					options: {
						priority: 1.1,
						separator: 'top',
						values: {
							'channel': 'Channel',
							'video': 'Video',
							'collection': 'Collection'
						},
						condition: {
							type: 'twitch'
						}
					}
				},
				141: {
					id: 141,
					template_id: 11,
					codename: 'twitch-content-id',
					type: 'string',
					title: 'Content id',
					value: '',
					control: 'input',
					options: {
						priority: 1.11,
						condition: {
							type: 'twitch'
						}
					}
				},
				142: {
					id: 142,
					template_id: 11,
					codename: 'amazon-iframe-id',
					type: 'string',
					title: 'IFrame id',
					value: '',
					control: 'input',
					options: {
						separator: 'top',
						priority: 1.1,
						condition: {
							type: 'amazon'
						}
					}
				},
				143: {
					id: 143,
					template_id: 11,
					codename: 'amazon-source',
					type: 'string',
					title: 'Source',
					value: '',
					control: 'input',
					options: {
						priority: 1.11,
						condition: {
							type: 'amazon'
						}
					}
				},
				144: {
					id: 144,
					template_id: 11,
					codename: 'amazon-style',
					type: 'string',
					title: 'Style',
					value: '',
					control: 'input',
					options: {
						priority: 1.12,
						condition: {
							type: 'amazon'
						}
					}
				},
				145: {
					id: 145,
					template_id: 11,
					codename: 'spotify-iframe-id',
					type: 'string',
					title: 'IFrame id',
					value: '',
					control: 'input',
					options: {
						separator: 'top',
						priority: 1.1,
						condition: {
							type: 'spotify'
						}
					}
				},
				146: {
					id: 146,
					template_id: 11,
					codename: 'spotify-source',
					type: 'string',
					title: 'Source',
					value: '',
					control: 'input',
					options: {
						priority: 1.11,
						condition: {
							type: 'spotify'
						}
					}
				},
				147: {
					id: 147,
					template_id: 11,
					codename: 'deezer-url',
					type: 'string',
					title: 'Source',
					value: '',
					control: 'input',
					options: {
						separator: 'top',
						priority: 1.1,
						condition: {
							type: 'deezer'
						}
					}
				},
				148: {
					id: 148,
					template_id: 11,
					codename: 'destroy-on-click',
					title: 'Destroy on click',
					type: 'string',
					value: false,
					control: 'switch',
					options: {
						priority: 10,
						separator: 'top',
						condition: {
							'has-parent': true
						}
					}
				},
				149: {
					id: 149,
					template_id: 11,
					codename: 'z-index',
					title: 'Z-index',
					type: 'number',
					value: 0,
					control: 'input',
					options: {
						priority: 0.01,
						condition: {
							'has-parent': true
						}
					}
				},
				150: {
					id: 150,
					template_id: 11,
					title: 'Override asset width',
					codename: 'override-width',
					type: 'number',
					value: '',
					control: 'input-with-range',
					options: {
						priority: 2.95,
						condition: {
							'has-parent': true,
							'type': 'image'
						},
						range: [0, 1000, 1],
						separator: 'top'
					}
				},
				151: {
					id: 151,
					template_id: 11,
					title: 'Override asset height',
					codename: 'override-height',
					type: 'number',
					value: '',
					control: 'input-with-range',
					options: {
						priority: 2.96,
						condition: {
							'has-parent': true,
							'type': 'image'
						},
						range: [0, 1000, 1]
					}
				},
				152: {
					id: 152,
					template_id: 11,
					codename: 'force-expand',
					title: 'Force expand',
					type: 'boolean',
					value: false,
					control: 'switch',
					options: {
						priority: 1,
						separator: 'top',
						condition: {
							sectionCodename: 'floor-expanded'
						}
					}
				},
				153: {
					id: 153,
					template_id: 11,
					codename: 'collapse-on-click',
					title: 'Collapse on click',
					type: 'string',
					value: false,
					control: 'switch',
					options: {
						priority: 10.1,
						condition: {
							'has-parent': true,
							data: {
								'parentSection': 'expanded'
							}
						}
					}
				},
				154: {
					id: 154,
					template_id: 11,
					codename: 'autoplay',
					type: 'boolean',
					title: 'Autoplay',
					value: true,
					control: 'switch',
					options: {
						priority: 1.111,
						condition: {
							type: 'twitch'
						}
					}
				},
				155: {
					id: 155,
					template_id: 11,
					codename: 'reversed',
					title: 'Reverse behaviour',
					type: 'boolean',
					value: false,
					control: 'switch',
					options: {
						priority: 1,
						separator: 'top',
						condition: {
							sectionCodename: 'floor-collapsed'
						}
					}
				},
				156: {
					id: 156,
					template_id: 9,
					codename: 'twitch-type',
					type: 'string',
					title: 'Content type',
					value: 'channel',
					control: 'select',
					options: {
						priority: 1.1,
						separator: 'top',
						values: {
							'channel': 'Channel',
							'video': 'Video',
							'collection': 'Collection'
						},
						condition: {
							type: 'twitch'
						}
					}
				},
				157: {
					id: 157,
					template_id: 9,
					codename: 'twitch-content-id',
					type: 'string',
					title: 'Content id',
					value: '',
					control: 'input',
					options: {
						priority: 1.11,
						condition: {
							type: 'twitch'
						}
					}
				},
				158: {
					id: 158,
					template_id: 8,
					codename: 'html-text',
					title: 'HTML text',
					type: 'string',
					value: '',
					control: 'textarea',
					options: {
						separator: 'top',
						priority: 1.1,
						condition: {
							'has-parent': true,
							type: 'html'
						}
					}
				},
				159: {
					id: 159,
					template_id: 8,
					codename: 'playable-src',
					title: 'Playable source',
					type: 'string',
					value: '',
					control: 'input',
					options: {
						separator: 'top',
						priority: 1.1,
						condition: {
							'has-parent': true,
							type: 'playable'
						}
					}
				},
				160: {
					id: 160,
					template_id: 11,
					codename: 'width',
					type: 'number',
					title: 'Width (%)',
					value: 100,
					control: 'input',
					options: {
						separator: 'top',
						priority: 1.51,
						condition: {
							type: 'color'
						}
					}
				},
				161: {
					id: 161,
					template_id: 11,
					codename: 'height',
					type: 'number',
					title: 'Height (%)',
					value: 80,
					control: 'input',
					options: {
						priority: 1.52,
						condition: {
							type: 'color'
						}
					}
				},
				162: {
					id: 162,
					template_id: 11,
					codename: 'color',
					type: 'string',
					title: 'Color',
					value: '#ffffff',
					control: 'input-with-color',
					options: {
						additionalRightButton: true,
						priority: 1.5,
						separator: 'top',
						condition: {
							type: 'color'
						}
					}
				},
				163: {
					id: 163,
					template_id: 11,
					codename: 'collapse-on-mouse-out',
					title: 'Collapse on mouse out',
					type: 'boolean',
					value: true,
					control: 'switch',
					options: {
						priority: 2,
						separator: 'top',
						condition: {
							sectionCodename: ['floor-expanded']
						}
					}
				},
			};

			this.templateSettings = Object.values(this.templateSettings).sort((a, b) => {
				if (a.options.priority > b.options.priority) return 1;
				else return -1;
			});

			this.templateSettingsByTemplate = _.groupBy(this.templateSettings, 'template_id');

			return {
				expandedSectionId: null,
				type: 'image',
				isDownloadable: true,
				isReplaceable: true,
				isRemovable: false
			};

		},
		computed: {},
		methods: {
			collectData() {

				this.sections = Section.getSelectedProjectSections();

				this.sections.forEach(section => {
					if (section.Data.newTitle) section.title = section.Data.newTitle;
				});

				this.videoSections = this.sections.filter(section => section.type === 'video');

				this.videos = Asset.getVideos();

				let interstitialSection = Object.values(this.sections).find(section => section.type === 'interstitial');
				if (interstitialSection) {
					this.interstitialScreens = [];
					let numberOfScreens = interstitialSection.Data.numberOfScreens || 4;
					for (let i = 0; i < numberOfScreens; i++) {
						if (interstitialSection.Data[`screen-${i}`]) this.interstitialScreens.push(interstitialSection.Data[`screen-${i}`]);
						else this.interstitialScreens.push('Screen ' + (i + 1));
					}
				}

				if (Template.SelectedTemplate.id === 6) {
					let settings = Settings.getSelectedProjectSettings();
					let playerStyleSetting = settings.find(setting => setting.codename === 'player-style');
					if (playerStyleSetting) {
						this.playerStyle = playerStyleSetting.value;
					}
				}
			},
			checkConditions(section, setting) {
				let conditions = setting.options.condition;
				if (!conditions) return true;
				if (section.template_id !== setting.template_id) return false;
				let keys = Object.keys(conditions);
				for (let i = 0; i < keys.length; i++) {
					let key = keys[i];
					let value = conditions[key];

					if (key === 'sectionCodename') {
						if (Array.isArray(value)) {
							if (value[0] === 'not') {
								if (value.includes(section.codename)) return false;
							}
							else if (!value.find(val => val === section.codename)) return false;
						} else {
							if (section.codename !== value) return false;
						}
					}

					if (key === 'type') {
						if (Array.isArray(value)) {
							let c = value[0];
							if (c === 'or') {
								if (!value.includes(section.type)) return false;
							}
						} else {
							if (section.type !== value) return false;
						}
					}

					if (key === 'data') {
						let result = true;
						_.forEach(value, (v, k) => {
							if (!_.isEqual(section.Data[k], v)) {
								result = false;
								return false;
							}
						});
						if (!result) return false;
					}

					if (key === 'has-parent' && value) {
						if (!section.Data.hasOwnProperty('parentSection')) {
							return false;
						}
					}

					if (key === 'setting') {
						let projectSetting = Settings.SettingsByProjectByCodename[section.project_id][Object.keys(value)[0]];
						let requiredValue = Object.values(value)[0];
						if (projectSetting.type === 'boolean') {
							if (!projectSetting.hasOwnProperty('value')) return false;
							let bool = Boolean(parseInt(projectSetting.value));
							if (bool !== requiredValue) return false;
						} else {
							if (!projectSetting.hasOwnProperty('value') || projectSetting.value !== requiredValue) return false;
						}
					}
				}
				return true;
			},
			highlightSection(section, e) {

				let message = {
					sections: {},
					videos: {}
				};

				section.Data.highlighted = !section.Data.highlighted;

				message.sections[section['id']] = section;

				Broadcast.call("Send to IFrame", [message]);

				this.$forceUpdate();

				e.stopPropagation();

			},
			setSectionVideoForMobile(section, propertyName, value, videoName) {
				if (section.template_id !== 5) return;

				clearTimeout(this.setDataTimeout);

				this.setDataTimeout = setTimeout(() => {

					let message = {
						sections: {}
					};

					section.Data[propertyName] = value;

					if (Asset.Videos[videoName]) {
						let video = Asset.Videos[videoName];
						if (video.width && video.height) {
							section.Data['video-resolution'] = video.width / video.height;
						}
						else {
							section.Data['video-resolution'] = 16 / 9;
						}
					}
					else {
						section.Data['video-resolution'] = 16 / 9;

					}

					message.sections[section['id']] = section;

					Broadcast.call("Send to IFrame", [message]);

				}, 2000);
			},

			setSectionDataInstantly(section, propertyName, value) {

				let message = { sections: {} };

				section.Data[propertyName] = value;
				message.sections[section.id] = section;
				Broadcast.call("Send to IFrame", [message]);

				this.$forceUpdate();

			},

			setSectionData(section, propertyName, value, isUpdateInput = false, isSaveData = false) {

				if (propertyName === 'navigation-styling' && value === 'image') {
					Asset.createImageNavigation(section);
				} else if (propertyName === 'navigation-styling' && value === 'text') {
					for (let i = 1; i < 7; i++) {
						let asset = Asset.AssetsByProjectByCodename[section.project_id][`navigation-${i}`];
						if (asset) Asset.removeAsset(asset);
					}
				}

				clearTimeout(this.setDataTimeout);

				this.setDataTimeout = setTimeout(() => {

					let message = {
						sections: {}
					};

					if (!Array.isArray(value)) section.Data[propertyName] = value;
					else {
						for (let i = 0; i < propertyName.length; i++) {
							section.Data[propertyName[i]] = value[i];
						}
					}

					message.sections[section['id']] = section;

					Broadcast.call("Send to IFrame", [message]);

					if (isUpdateInput) this.$forceUpdate();

					if (isSaveData) Section.saveSectionData(section, propertyName, value);

				}, 2000);

			},

			setSectionScale(section, value) {
				section.Data.width *= value;
				section.Data.height *= value;
			},

			getMeta(section, url) {
				let width = 500;
				let height = 500;
				let img = new Image();
				img.onload = function () {
					let width = this.width || 500;
					let height = this.height || 500;
					Section.saveSectionData(section, ['width', 'height'], [width, height]);
				};
				img.src = url;
			},

			getSectionVisualEffectCss(section) {

				let value;
				if (!section.Data['visual-effect']) value =  '';

				if (section.Data['visual-effect'] && section.Data['visual-effect'] === 'glow') {
					value = '-webkit-filter: drop-shadow(0px 0px 7px rgba(255, 255, 255, 0.75));\n' +
     						'filter: drop-shadow(0px 0px 7px rgba(255, 255, 255, 0.75));';
					//Section.saveSectionData(section, 'visual-effect-css', value);
				}
				else if (section.Data['visual-effect'] && section.Data['visual-effect'] === 'jump') {
					value = 'animation: .4s vdrm-jump ease infinite alternate;';
				} else if (section.Data['visual-effect'] && section.Data['visual-effect'] === 'blink') {
					value = 'animation: vdrm-blink 1.33s ease-out infinite;';
				} else if (section.Data['visual-effect'] && section.Data['visual-effect'] === 'wiggle') {
					value = 'animation: 1s vdrm-wiggle ease infinite;';
				}
				else if (section.Data['visual-effect'] && section.Data['visual-effect'] === 'custom') {
					if (!section.Data['visual-effect-css'] || section.Data['visual-effect-css'].length === 0) {
						value = '-webkit-filter: drop-shadow(0px 0px 7px rgba(255, 0, 0, 0.75));\n' +
							'filter: drop-shadow(0px 0px 7px rgba(255, 0, 0, 0.75));';
					}
					else value = section.Data['visual-effect-css'];
				}

				//Section.saveSectionData(section, 'visual-effect-css', value);
				return value;
			},

			setSectionType(section, type, isUpdateInput = false) {

				if (type === 'html') {

					if (section.Data.html) this.calculateSize(section);

				} else if (type === 'image' && section.Data.assetId) {

					this.getMeta(section, Asset.Assets[section.Data.assetId].mergedAssetData.url);

				}

				let message = {
					sections: {}
				};

				section.type = type;

				message.sections[section['id']] = section;

				Broadcast.call("Send to IFrame", [message]);

				if (isUpdateInput) this.$forceUpdate();

			},

			setSectionStyle(section, propertyName, value) {

				let message = {
					sections: {}
				};

				section.Data['styles'][propertyName] = value;

				message.sections[section['id']] = section;

				Broadcast.call("Send to IFrame", [message]);

			},

			saveSectionStyle(section, propertyName, value) {

				if (!section.Data.styles) section.Data.styles = {};

				section.Data['styles'][propertyName] = value;

				Server.sendToSocket({
					SetSectionStyle: {
						sectionId: section.id,
						propertyName: propertyName,
						value: value
					}
				});

			},

			onSizeInput(property, value) {
				let section = Section.Sections[this.expandedSectionId];

				if (!section) return;

				let message = {
					sections: {}
				};

				section.Data[property] = Math.ceil(parseFloat(value));

				message.sections[section['id']] = section;

				Broadcast.call("Send to IFrame", [message]);

				this.$forceUpdate();
			},
			onSizeChanged(property, value) {

				let section = Section.Sections[this.expandedSectionId];
				if (!section) return;

				Section.saveSectionData(section, property, Math.ceil(parseFloat(value)));
			},
			onRangeInput(value, settingCodename) {
				let section = Section.Sections[this.expandedSectionId];

				if (!section) return;

				let message = {
					sections: {}
				};

				section.Data[settingCodename] = parseFloat(value);

				message.sections[section['id']] = section;

				Broadcast.call("Send to IFrame", [message]);

				this.$forceUpdate();
			},
			onRangeChanged(value, settingCodename) {

				let section = Section.Sections[this.expandedSectionId];
				if (!section) return;

				Section.saveSectionData(section, settingCodename, parseFloat(value));
			},
			onOffsetYInput(value) {
				let section = Section.Sections[this.expandedSectionId];

				if (!section) return;

				let message = {
					sections: {}
				};

				section.Data.offsetY = parseFloat(value);

				message.sections[section['id']] = section;

				Broadcast.call("Send to IFrame", [message]);

				this.$forceUpdate();
			},
			onOffsetYChanged(value) {

				let section = Section.Sections[this.expandedSectionId];
				if (!section) return;

				Section.saveSectionData(section, 'offsetY', parseFloat(value));
			},
			onOffsetInput(x, y, property) {


				let section = Section.Sections[this.expandedSectionId];
				if (!section) return;

				let message = {
					sections: {}
				};

				section.Data[`${property}X`] = parseFloat(x).toFixed(3);
				section.Data[`${property}Y`] = parseFloat(y).toFixed(3);

				message.sections[section['id']] = section;

				Broadcast.call("Send to IFrame", [message]);

				this.$forceUpdate();

			},

			onCollapsedOffsetInput(x, y) {

				let section = Section.Sections[this.expandedSectionId];
				if (!section) return;

				let message = {
					sections: {}
				};

				section.Data['collapsedOffsetX'] = parseFloat(x).toFixed(3);
				section.Data['collapsedOffsetY'] = parseFloat(y).toFixed(3);

				message.sections[section['id']] = section;

				Broadcast.call("Send to IFrame", [message]);

				this.$forceUpdate();

			},
			onFixedOffsetInput(x, y) {

				let section = Section.Sections[this.expandedSectionId];
				if (!section) return;

				let message = {
					sections: {}
				};

				section.Data['fixedOffsetX'] = parseFloat(x).toFixed(3);
				section.Data['fixedOffsetY'] = parseFloat(y).toFixed(3);

				message.sections[section['id']] = section;

				Broadcast.call("Send to IFrame", [message]);

				this.$forceUpdate();

			},
			onOffsetChanged(x, y, property) {

				let section = Section.Sections[this.expandedSectionId];
				if (!section) return;

				Section.saveSectionData(section, `${property}X`, parseFloat(x).toFixed(3));
				Section.saveSectionData(section, `${property}Y`, parseFloat(y).toFixed(3));

			},
			onCollapsedOffsetChanged(x, y) {

				let section = Section.Sections[this.expandedSectionId];
				if (!section) return;

				Section.saveSectionData(section, 'collapsedOffsetX', parseFloat(x).toFixed(3));
				Section.saveSectionData(section, 'collapsedOffsetY', parseFloat(y).toFixed(3));

			},
			onFixedOffsetChanged(x, y) {

				let section = Section.Sections[this.expandedSectionId];
				if (!section) return;

				Section.saveSectionData(section, 'fixedOffsetX', parseFloat(x).toFixed(3));
				Section.saveSectionData(section, 'fixedOffsetY', parseFloat(y).toFixed(3));

			},
			onAnchorInput(x, y, property) {

				//console.log('onAnchorInput', x, y);

				x = x / 2 + 0.5;
				y = y / 2 + 0.5;

				let section = Section.Sections[this.expandedSectionId];
				if (!section) return;

				let message = {
					sections: {}
				};

				section.Data[`${property}X`] = parseFloat(x).toFixed(3);
				section.Data[`${property}Y`] = parseFloat(y).toFixed(3);

				message.sections[section['id']] = section;

				Broadcast.call("Send to IFrame", [message]);

				this.$forceUpdate();

			},
			onCollapsedAnchorInput(x, y) {

				console.log('onAnchorInput', x, y);

				x = x / 2 + 0.5;
				y = y / 2 + 0.5;

				let section = Section.Sections[this.expandedSectionId];
				if (!section) return;

				let message = {
					sections: {}
				};

				section.Data['collapsedAnchorX'] = parseFloat(x).toFixed(3);
				section.Data['collapsedAnchorY'] = parseFloat(y).toFixed(3);

				message.sections[section['id']] = section;

				Broadcast.call("Send to IFrame", [message]);

				this.$forceUpdate();

			},
			onFixedAnchorInput(x, y) {

				console.log('onAnchorInput', x, y);

				x = x / 2 + 0.5;
				y = y / 2 + 0.5;

				let section = Section.Sections[this.expandedSectionId];
				if (!section) return;

				let message = {
					sections: {}
				};

				section.Data['fixedAnchorX'] = parseFloat(x).toFixed(3);
				section.Data['fixedAnchorY'] = parseFloat(y).toFixed(3);

				message.sections[section['id']] = section;

				Broadcast.call("Send to IFrame", [message]);

				this.$forceUpdate();

			},
			onAnchorChanged(x, y, property) {

				//console.log('onAnchorChanged', x, y);

				x = x / 2 + 0.5;
				y = y / 2 + 0.5;

				let section = Section.Sections[this.expandedSectionId];
				if (!section) return;

				Section.saveSectionData(section, `${property}X`, parseFloat(x).toFixed(3));
				Section.saveSectionData(section, `${property}Y`, parseFloat(y).toFixed(3));

			},
			onCollapsedAnchorChanged(x, y) {

				console.log('onAnchorChanged', x, y);

				x = x / 2 + 0.5;
				y = y / 2 + 0.5;

				let section = Section.Sections[this.expandedSectionId];
				if (!section) return;

				Section.saveSectionData(section, 'collapsedAnchorX', parseFloat(x).toFixed(3));
				Section.saveSectionData(section, 'collapsedAnchorY', parseFloat(y).toFixed(3));

			},
			onFixedAnchorChanged(x, y) {

				console.log('onAnchorChanged', x, y);

				x = x / 2 + 0.5;
				y = y / 2 + 0.5;

				let section = Section.Sections[this.expandedSectionId];
				if (!section) return;

				Section.saveSectionData(section, 'fixedAnchorX', parseFloat(x).toFixed(3));
				Section.saveSectionData(section, 'fixedAnchorY', parseFloat(y).toFixed(3));

			},

			expandSection(section, event) {

				if (event.target.closest('.asset-list-main .asset-list-edit')) return;

				this.expandedSectionId = section.id;

			},
			collapseSection() {

				this.expandedSectionId = null;

			},

			resetSection(section) {

				//section.Data.styles.visibility = 'visible';

				let title = section.title;

				let templateSection = Object.values(this.Metadata.TemplateSectionsByTemplateIdByCodename[section.template_id]).find((section_) => {
					return section_.codename === section.codename;
				});

				let data = _.cloneDeep(templateSection.Data);
				data.assetId = section.Data.assetId;
				if (section.Data.newTitle) data.newTitle = section.Data.newTitle;

				let type = templateSection.type;

				let message = {
					sections: {}
				};

				section.type = type;

				section.Data = _.cloneDeep(data);
				section.data = JSON.stringify(data);

				message.sections[section['id']] = section;

				Broadcast.call("Send to IFrame", [message]);

				Section.resetSection(section.id, section.data, section.type);

			},

			disableSection(section) {

				let value;
				if (!section.Data.disabled) {
					value = true;
					section.Data.disabled = true;
					Section.saveSectionData(section, 'disabled', true);
				} else {
					section.Data.disabled = false;
					value = false;
					Section.saveSectionData(section, 'disabled', false);
				}

				let message = {
					refresh: {}
				};

				section.Data['disabled'] = value;

				Broadcast.call("Send to IFrame", [message]);

				this.$forceUpdate();
			},

			selectTemplate(target) {
				console.log(target);
			},

			createNewSection() {

				Broadcast.call("Show Section Actions Create");

			},

			showChangeHistory() {
				Broadcast.call("Show Sections Changes History")
			},

			deleteSection(sectionId) {

				Broadcast.call("Show Section Actions Remove", [sectionId]);
				Broadcast.call("Section Selected", [sectionId]);

			},

			pressButton(section, value) {
				let btnFixedRation = document.getElementById('btn-fixed-ratio').parentNode;
				let btnFixedSize = document.getElementById('btn-fixed-size').parentNode;

				switch(value.target.id) {
					case 'btn-fixed-ratio':
						btnFixedRation.classList.add('active');
						btnFixedSize.classList.remove('active');
						Section.saveSectionData(section, 'videoSizeMode', 'ratio')
						break;
					case 'btn-fixed-size':
						btnFixedSize.classList.add('active');
						btnFixedRation.classList.remove('active');
						Section.saveSectionData(section, 'videoSizeMode', 'fixed')
						break;
				}
			},

			getBackgroundColor(section, index) {
				let assetName = section.Data[`segment-${index}-bg`] || 'background';
				Section.getBackgroundColorForSection(section, `segment-${index}-bg-color`, assetName);
			},

			colorInput(section, setting) {
				const assetName = section.Data.parentSection === 'collapsed' ? 'floor-collapsed' : 'floor-expanded';
				Section.getBackgroundColorForSection(section, setting.codename, assetName);
			},

			calculateSize(section) {

				if (!section.Data.html) return;

				let outer = document.createElement('div');
				outer.style.display = 'inline-block';
				outer.style.visibility = 'hidden';
				document.body.appendChild(outer);

				outer.innerHTML = section.Data.html;
				outer.display = 'flex';

				let rect;

				try {
					rect = outer.children.item(0).getBoundingClientRect();
				} catch (err) {
					return;
				}
				outer.parentNode.removeChild(outer);

				let width = Math.ceil(rect.width);
				let height = Math.ceil(rect.height);
				section.Data.width = width;
				section.Data.height = height;

				this.setSectionData(section, ['width', 'height'], [width, height], true, true);

			}
		}
	}
</script>

<style lang="sass">

	.position-settings
		display: flex
		flex-direction: row

		.horizontal-part
			display: flex
			flex-direction: column

			.in-a-row
				display: flex
				flex-direction: row
				align-items: center

				small
					display: block
					width: 120px

			.setting-control-coordinates
				margin-top: 2px
				margin-left: 10px

	.section-list-item-settings.new-settings
		padding: 5px
		border-top: 1px solid #23282c
		border-bottom: 1px solid #23282c

		.section-settings.in-a-row
			padding-bottom: 2px

			&:empty
				display: none

			.condition-wrapper
				display: flex
				flex-direction: row
				align-items: center

				&.inner-tabs-wrapper
					display: flex
					flex-direction: column

					>.inner-tab
						width: 100%
						border-top: 1px solid #23282c

				.right-part-wrapper
					display: flex
					flex-direction: row
					align-items: center
					gap: 10px
					width: 100%

					&.input-with-color
						>input
							background-color: #515b65
							border: 1px solid #23282c
							color: white

					&.input-with-range

						input
							width: 50px

						input.range
							width: 100%


				select
					width: 100%
					margin-top:	unset

				&.separator-bottom
					border-bottom: 1px solid #23282c
				&.separator-top
					border-top: 1px solid #23282c
					padding-top: 3px

				.left-title
					width: 120px
					padding-right: 10px
					min-width: 120px
					font-size: 100%

				input.right-control
					border: 1px solid #23282c
					background-color: #515b65
					color: white

				>textarea
					background-color: #515b65
					border: 1px solid #23282c
					color: white

				.horizontal-part
					display: flex
					flex-direction: column
					padding-right: 10px

					.in-a-row
						display: flex
						flex-direction: row
						padding: 2px 0

						input
							background-color: #515b65
							border-color: #23282c
							color: white

	.section-settings-tab
		padding: 5px
		display: flex
		flex-direction: column
		font-size: 0.875rem
		border-top: 1px solid #23282c

		.in-a-row
			display: flex
			flex-direction: row
			align-items: center
			padding: 2px 0

			small:first-letter
				text-transform: uppercase

			select, input
				width: 120px

			.auto-width
				width: auto

			.margin-left
				margin-left: 5px

			.no-bg
				background: none
				border: none

			.left-title
				width: 120px
				padding-right: 10px
				min-width: 120px

			.default-width
				width: 100px
			.small-width
				width: 50px
			.full-width
				width: 100%

			textarea, input
				color: #ffffff
				background-color: #515b65
				border: solid 1px #23282c
				border-radius: 0.25rem
				padding: 7px

				&::-webkit-scrollbar
					appearance: none
					background-color: #343434
					width: 5px
				&::-webkit-scrollbar-thumb
					background-color: #3a4149
				&::-webkit-resizer
					display: none

				&:disabled
					color: #a3a1a1

				&::placeholder
					color: rgba(255, 255, 255, 0.1)

	.poll-setting
		display: flex
		width: 100%

		small
			margin: auto 0px


	.poll-button
		display: flex
		-webkit-box-orient: vertical
		-webkit-box-direction: normal
		-ms-flex-direction: column
		flex-direction: column
		-webkit-box-align: center
		-ms-flex-align: center
		align-items: center
		width: 100%
		border-bottom: 1px solid #23282c
		padding: 5px 0

		.section-settings
			width: 100%

		&:last-of-type
			border-bottom: none

		input.right-control
			width: unset



	.project-settings-sections
		margin-top: 20px

		.sections-header
			display: flex
			justify-content: space-between

			.create-new-section-button
				cursor: pointer
				padding: 0 9px
				font-size: 16px
				transition: 0.2s

				&:hover
					color: #20a8d8

			.controls-wrapper
				display: flex


			.show-history-button
				cursor: pointer
				padding: 0 9px
				font-size: 16px
				transition: 0.2s

				&:hover
					color: #20a8d8

		input::-webkit-outer-spin-button, input::-webkit-inner-spin-button
			-webkit-appearance: none
			margin: 0

		input[type=number]
			-moz-appearance: textfield



		.section-list-empty
			padding: 5px
			color: #73818f

		.section-list
			position: relative
			margin-top: 5px
			border: 1px solid #23282c
			border-radius: 5px
			background-color: #343b41
			font-size: 12px
			overflow: hidden

			.section-list-item
				position: relative
				user-select: none

				&:not(:first-child)
					border-top: 1px solid rgba(0, 0, 0, 0.1)

				&:hover
					background-color: #2f363c

				.section-list-name
					padding: 5px 0 5px 5px
					max-width: 170px
					overflow: hidden
					text-overflow: ellipsis

					span
						line-height: 14px
						display: block
						white-space: nowrap
						text-overflow: ellipsis
						overflow: hidden
						height: 15px

				.section-list-main
					display: flex
					position: relative
					justify-content: space-between
					border-top: 1px solid #23282c
					cursor: pointer
					transition: 0.2s
					user-select: none

					&:first-child
						border-top: none

					.section-list-edit
						display: flex

						.icon-info
							color: #20a8d8
							font-size: 0.8rem !important
							display: inline-block
							margin-top: 5px

						.section-list-edit-item
							cursor: pointer
							transition: 0.2s
							padding: 2px 7px
							font-size: 14px
							color: #fff

							&:hover
								color: #20a8d8

							&:last-child
								margin-right: 2px

							&.control-item
								opacity: 0.1

							&.red
								color: #f86c6b

							&.orange
								color: #f8cb00

				.section-list-item-settings

					.section-element-settings
						padding: 5px 5px 5px 5px
						border-top: 1px solid #23282c
						display: flex
						flex-direction: column

						& > .poll-button
							flex-direction: column

							div
								width: 100%

						& > div
							display: flex
							flex-direction: row
							align-items: center

							small
								display: block
								width: 120px

							input.range
								width: 140px
								margin-left: auto
								margin-right: 2px

						.screens-settings
							display: flex
							flex-direction: column

							.in-a-row
								display: flex
								flex-direction: row
								align-items: center
								width: 100%
								height: 35px

								small
									display: block
									width: 120px

						.interstitial-video-tab
							margin-top: 5px
							padding-top: 5px
							border-top: 1px solid #23282c
							display: flex
							flex-direction: column

							.interstitial-section-position-settings
								width: 100%
								display: flex
								flex-direction: row

								.horizontal-part
									display: flex
									flex-direction: column

								.in-a-row
									display: flex
									flex-direction: row
									align-items: center

									small
										display: block
										width: 120px

								.setting-control-coordinates
									margin-top: 2px
									margin-left: 10px

							.in-a-row
								display: flex
								flex-direction: row
								align-items: center
								width: 100%

								small
									display: block
									width: 120px

						.interstitial-video-tab:not(:last-child)
							padding-bottom: 10px
							border-bottom: 1px solid #23282c


					.section-position-settings
						padding: 5px 5px 5px 5px
						border-top: 1px solid #23282c
						display: flex
						flex-direction: row

						.horizontal-part
							display: flex
							flex-direction: column

						.in-a-row
							display: flex
							flex-direction: row
							align-items: center

							small
								display: block
								width: 120px

						.setting-control-coordinates
							margin-top: 2px
							margin-left: 10px

					.section-image-settings
						padding: 5px 5px 5px 5px
						border-top: 1px solid #23282c

						.left-title
							padding-top: 8px

						.right-control
							margin-left: auto

						.section-image-setting
							display: flex
							flex-direction: row

						select
							margin-top: 2px

					.section-video-settings
						padding: 5px 5px 5px 5px
						border-top: 1px solid #23282c
						display: flex
						flex-direction: column
						font-size: 14px

						.section-position-settings
							padding: 5px 5px 5px 5px
							border-top: 1px solid #23282c
							display: flex
							flex-direction: row


						.video-setting
							padding-top: 5px
							padding-bottom: 5px
							display: flex
							flex-direction: row

							.horizontal-part
								display: flex
								flex-direction: column

							.in-a-row
								display: flex
								flex-direction: row
								align-items: center

								small
									display: block
									width: 120px

							.setting-control-coordinates
								margin-top: 2px
								margin-left: 10px

							.btn-group
								label
									font-size: 12px
									cursor: pointer

							input.form-control.form-control-sm
								margin-top: 2px
								border: 1px solid #23282c
								background-color: #515b65
								background-clip: padding-box
								height: calc(1.5em + 0.5rem + 3px)
								color: #e4e7ea

								&::placeholder
									color: rgba(255, 255, 255, 0.1)

								&[type="color"]
									width: 150px


							small

								margin-top: auto
								margin-bottom: auto
								display: block
								width: 125px

							right-control
								margin-left: auto
								margin-right: auto




					.section-hover-settings
						padding: 5px 5px 5px 5px
						border-top: 1px solid #23282c
						display: flex
						flex-direction: column

						.left-title
							padding-top: 8px

						.right-control
							margin-left: auto

						.section-image-setting
							display: flex
							flex-direction: row

						label
							margin-top: 2px
							margin-right: 30px

						select
							margin-top: 5px

					.section-hover-timer-settings
						padding: 5px 5px 5px 5px
						border-top: 1px solid #23282c
						display: flex
						flex-direction: column

						& > div
							display: flex
							flex-direction: row
							align-items: center

							small
								display: block
								width: 200px

							input.range
								width: 140px
								margin-left: auto
								margin-right: 2px

							label
								margin-top: 2px
								margin-right: 30px
								margin-bottom: 2px

					.calculate-size-button
						padding: 5px 5px 5px 5px
						display: flex
						flex-direction: column
						cursor: pointer
						color: #e4e7ea

						.left-title
							font-size: 13px
							vertical-align: center


					.delete-section-button
						padding: 5px 5px 5px 5px
						border-top: 1px solid #23282c
						display: flex
						flex-direction: column
						cursor: pointer
						color: #e4e7ea


						.left-title
							font-size: 13px
							//color: #dc143c
							vertical-align: center


					.section-content-settings
						padding: 5px 5px 5px 5px
						border-top: 1px solid #23282c
						display: flex
						flex-direction: row
						align-items: center

						textarea
							margin: 3px
							color: #ffffff
							padding: 7px
							border: 1px solid #23282c
							background-color: #515b65
							border-radius: 5px

						textarea:disabled
							color: #a3a1a1

						& > div
							display: flex
							flex-direction: row
							align-items: center

							small
								display: block
								width: 120px

							select
								margin-top: 0px




			.inline-controls
				display: flex
				flex-direction: row
				align-items: center

				small
					margin-right: 10px

				.range
					margin-left: 10px
					margin-top: 3px

			.section-list-item:hover

				.section-list-main

					.section-list-edit

						.section-list-edit-item

							&.control-item
								opacity: 1

			.section-list-item.expanded

				.section-list-main
					cursor: default

					.section-list-name

						span
							white-space: normal
							overflow: visible
							height: auto

					.section-list-edit-item

						&.control-item
							opacity: 1

				.play-on-event-list
					cursor: default

			.section-list-item.disabled

				.section-list-main
					color: #73818f

					.section-list-name
						text-decoration: line-through

			select
				border: 1px solid #23282c
				background-color: #515b65


		.create-new-section-button
			cursor: pointer
			padding: 0 9px
			font-size: 16px
			transition: 0.2s

			&:hover
				color: #20a8d8

		.horizontal-part-position
			display: flex
			flex-direction: column

			.in-a-row
				display: flex
				flex-direction: row
				align-items: center

				small
					display: block
					width: 120px



</style>
